<section class="section-div">
  <div class="header-div">
    <h4><ion-icon name="earth-outline"></ion-icon> Social Impact</h4>
  </div>
  <div class="content-details">
    <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start">
      <mat-tab label="Objective">
        <div class="content-div p-4">
          <ul class="objective-ul">
            <li>
              This area highlights the ability of the Incubation Center to
              demonstrate with real cases and examples the Social Impact created
              in the local community, work to attain inclusivity, diversity of
              stakeholders and beneficiaries of the support and program offered.
            </li>
            <li>
              Social Impact can be defined as the net effect of an activity on a
              community and the well-being of individuals and families and to
              create positive, meaningful and sustainable systems change for the
              benefit of our community. This is particularly for those at
              disadvantage as a result of complex and long-term systemic issues.
            </li>
          </ul>
        </div>
      </mat-tab>
      <mat-tab label="Scoring Criteria">
        <div class="content-div p-4">
          <ul class="objective-ul">
            <li>
              Circular Economy; Initiatives; Social Impact Startups;
              Environmental Sustainability; Women Leadership; Social
              Improvement; SC/ST Community Development; Agricultural
              Development; Rural Development
            </li>
          </ul>
        </div>
      </mat-tab>
    </mat-tab-group>

    <div class="content-div mb-2">
      <div class="d-flex" *ngIf="mobileQuery.matches == false">
        <h5 class="mb-3">Questions</h5>
      </div>

      <div class="row">
        <div
          class="col-lg-12 col-md-12 col-sm-12 col-12"
          [formGroup]="settingsForm"
        >
          <mat-accordion>
            <!-- qusetion 001 -->
            <mat-expansion-panel [expanded]="step === 0" (opened)="setStep(0)">
              <mat-expansion-panel-header class="d-flex">
                <h6>01.&nbsp;</h6>
                <h6>
                  <span *ngIf="mobileQuery.matches == false">
                    Women led Startups with minimum 51% Stake with a woman
                    founder or co-founder
                  </span>
                  <span *ngIf="mobileQuery.matches == true">Question</span>
                </h6>
                <div class="success-span ml-auto">
                  <div
                    class="set success"
                    [style.width]="pickWidth(getValue.womenLedStartupsStatus)"
                    [style.background]="
                      pickColor(getValue.womenLedStartupsStatus)
                    "
                  >
                    <svg
                      version="1.1"
                      id="check"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 100 100"
                      xml:space="preserve"
                    >
                      <circle
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-miterlimit: 10;
                        "
                        cx="49.799"
                        cy="49.746"
                        r="44.757"
                      />
                      <polyline
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-linecap: round;
                          stroke-linejoin: round;
                          stroke-miterlimit: 10;
                        "
                        points="
                                                27.114,51 41.402,65.288 72.485,34.205 "
                      />
                    </svg>
                    <span
                      [innerHTML]="innerValue(getValue.womenLedStartupsStatus)"
                    ></span>
                  </div>
                </div>
              </mat-expansion-panel-header>
              <div class="answer-div">
                <div class="row">
                  <div class="col-12 mb-2" *ngIf="mobileQuery.matches == true">
                    <h6>
                      Women led Startups with minimum 51% Stake with a woman
                      founder or co-founder
                    </h6>
                  </div>
                  <div class="col-lg-8 col-md-8 col-12">
                    <div
                      *ngIf="
                        getValue.womenLedStartupsStatus != 2 &&
                        getValue.womenLedStartupsStatus != 4 &&
                        getValue.womenLedStartupsStatus != 5 &&
                        getValue.womenLedStartupsStatus != 6
                      "
                    >
                      <div class="mt-3">
                        <mat-radio-group
                          formControlName="womenLedStartupsIncCentre"
                          [(ngModel)]="Optionsonechecked"
                          class="example-margin mt-4"
                          aria-label="Select an option"
                          (change)="
                            showOptionsone(
                              $event.value,
                              '.upload0',
                              0,
                              '.set-succ0'
                            )
                          "
                          [ngClass]="{
                            'is-invalid':
                              setting.womenLedStartupsIncCentre.touched &&
                              setting.womenLedStartupsIncCentre.errors
                          }"
                        >
                          <mat-radio-button value="Yes">Yes</mat-radio-button>
                          <mat-radio-button value="No">No</mat-radio-button>
                        </mat-radio-group>
                        <br />
                        <mat-error
                          *ngIf="
                            setting.womenLedStartupsIncCentre.touched &&
                            setting.womenLedStartupsIncCentre.errors
                          "
                        >
                          <span
                            *ngIf="
                              setting.womenLedStartupsIncCentre.errors.required
                            "
                            >Answer is required</span
                          >
                        </mat-error>
                      </div>
                      <div class="opt-div" *ngIf="Optionsonechecked == 'Yes'">
                        <div class="row">
                          <div class="col-lg-6 col-md-6 col-12">
                            <mat-form-field
                              class="material-full-width"
                              appearance="outline"
                            >
                              <mat-label
                                >Percentage of Women-led Startups
                                <span class="text-danger">*</span></mat-label
                              >
                              <input
                                matInput
                                placeholder="Enter No of  Percentage of Women-led Startups"
                                oninput="this.value = this.value.replace(/[^0-9]/g,'')"
                                (change)="
                                  setStatus($event, 'womenLedStartupsStatus', 7)
                                "
                                formControlName="womenledStartupFoundersPercent"
                                [ngClass]="{
                                  'is-invalid':
                                    setting.womenledStartupFoundersPercent
                                      .touched &&
                                    setting.womenledStartupFoundersPercent
                                      .errors
                                }"
                              />
                              <mat-error
                                *ngIf="
                                  setting.womenledStartupFoundersPercent
                                    .touched &&
                                  setting.womenledStartupFoundersPercent.errors
                                "
                              >
                                <span
                                  *ngIf="
                                    setting.womenledStartupFoundersPercent
                                      .errors.required
                                  "
                                  >Percentage of Women-led Startups is
                                  required</span
                                >
                              </mat-error>
                            </mat-form-field>
                            <mat-form-field
                              class="material-full-width"
                              appearance="outline"
                            >
                              <mat-label
                                >Total no. of incubated Startups<span
                                  class="text-danger"
                                  >*</span
                                ></mat-label
                              >
                              <input
                                matInput
                                placeholder="Enter Total no. of incubated Startups"
                                oninput="this.value = this.value.replace(/[^0-9]/g,'')"
                                (change)="
                                  setStatus($event, 'womenLedStartupsStatus', 7)
                                "
                                formControlName="womenledStartupFoundersCount"
                                [ngClass]="{
                                  'is-invalid':
                                    setting.womenledStartupFoundersCount
                                      .touched &&
                                    setting.womenledStartupFoundersCount.errors
                                }"
                              />
                              <mat-error
                                *ngIf="
                                  setting.womenledStartupFoundersCount
                                    .touched &&
                                  setting.womenledStartupFoundersCount.errors
                                "
                              >
                                <span
                                  *ngIf="
                                    setting.womenledStartupFoundersCount.errors
                                      .required
                                  "
                                  >Total no. of incubated Startups is
                                  required</span
                                >
                              </mat-error>
                            </mat-form-field>
                          </div>
                          <div class="col-lg-6 col-md-6 col-12">
                            <div class="main-wrapper">
                              <div class="upload-main-wrapper">
                                <div class="upload-wrapper upload0">
                                  <input
                                    type="file"
                                    formControlName="womenLedStartupsImagefile"
                                    (change)="
                                      fileUpload(
                                        $event,
                                        '.upload0',
                                        0,
                                        '.set-succ0'
                                      )
                                    "
                                    id=""
                                    [ngClass]="{
                                      'is-invalid':
                                        setting.womenLedStartupsImagefile
                                          .touched &&
                                        setting.womenLedStartupsImagefile.errors
                                    }"
                                  />
                                  <svg
                                    version="1.1"
                                    xmlns="http://www.w3.org/2000/svg"
                                    xmlns:xlink="http://www.w3.org/1999/xlink"
                                    preserveAspectRatio="xMidYMid meet"
                                    viewBox="224.3881704980842 176.8527621722847 221.13266283524905 178.8472378277154"
                                    width="221.13"
                                    height="178.85"
                                  >
                                    <defs>
                                      <path
                                        d="M357.38 176.85C386.18 176.85 409.53 204.24 409.53 238.02C409.53 239.29 409.5 240.56 409.42 241.81C430.23 246.95 445.52 264.16 445.52 284.59C445.52 284.59 445.52 284.59 445.52 284.59C445.52 309.08 423.56 328.94 396.47 328.94C384.17 328.94 285.74 328.94 273.44 328.94C246.35 328.94 224.39 309.08 224.39 284.59C224.39 284.59 224.39 284.59 224.39 284.59C224.39 263.24 241.08 245.41 263.31 241.2C265.3 218.05 281.96 199.98 302.22 199.98C306.67 199.98 310.94 200.85 314.93 202.46C324.4 186.96 339.88 176.85 357.38 176.85Z"
                                        id="b1aO7LLtdW"
                                      ></path>
                                      <path
                                        d="M306.46 297.6L339.79 297.6L373.13 297.6L339.79 255.94L306.46 297.6Z"
                                        id="c4SXvvMdYD"
                                      ></path>
                                      <path
                                        d="M350.79 293.05L328.79 293.05L328.79 355.7L350.79 355.7L350.79 293.05Z"
                                        id="b11si2zUk"
                                      ></path>
                                    </defs>
                                    <g>
                                      <g>
                                        <g>
                                          <use
                                            xlink:href="#b1aO7LLtdW"
                                            opacity="1"
                                            fill="#ffffff"
                                            fill-opacity="1"
                                          ></use>
                                        </g>
                                        <g>
                                          <g>
                                            <use
                                              xlink:href="#c4SXvvMdYD"
                                              opacity="1"
                                              fill="#363535"
                                              fill-opacity="1"
                                            ></use>
                                          </g>
                                          <g>
                                            <use
                                              xlink:href="#b11si2zUk"
                                              opacity="1"
                                              fill="#363535"
                                              fill-opacity="1"
                                            ></use>
                                          </g>
                                        </g>
                                      </g>
                                    </g>
                                  </svg>
                                  <span class="file-upload-text"
                                    >Upload Documentary</span
                                  >
                                  <div class="file-success-text">
                                    <svg
                                      version="1.1"
                                      id="check"
                                      xmlns="http://www.w3.org/2000/svg"
                                      xmlns:xlink="http://www.w3.org/1999/xlink"
                                      x="0px"
                                      y="0px"
                                      viewBox="0 0 100 100"
                                      xml:space="preserve"
                                    >
                                      <circle
                                        style="
                                          fill: rgba(0, 0, 0, 0);
                                          stroke: #ffffff;
                                          stroke-width: 10;
                                          stroke-miterlimit: 10;
                                        "
                                        cx="49.799"
                                        cy="49.746"
                                        r="44.757"
                                      />
                                      <polyline
                                        style="
                                          fill: rgba(0, 0, 0, 0);
                                          stroke: #ffffff;
                                          stroke-width: 10;
                                          stroke-linecap: round;
                                          stroke-linejoin: round;
                                          stroke-miterlimit: 10;
                                        "
                                        points="
                            27.114,51 41.402,65.288 72.485,34.205 "
                                      />
                                    </svg>
                                    <span>Uploading</span>
                                  </div>
                                </div>
                                <mat-error
                                  *ngIf="
                                    setting.womenLedStartupsImagefile.touched &&
                                    setting.womenLedStartupsImagefile.errors
                                  "
                                >
                                  <span
                                    *ngIf="
                                      setting.womenLedStartupsImagefile.errors
                                        .required
                                    "
                                    >Documentary is required</span
                                  >
                                </mat-error>
                                <div
                                  class="remove-wrapper upload0"
                                  (click)="
                                    removeFile('.upload0', 0, '.set-succ0')
                                  "
                                >
                                  <div class="file-success-text">
                                    <ion-icon
                                      name="close-circle-outline"
                                    ></ion-icon
                                    ><span>Remove Documentary</span>
                                  </div>
                                </div>
                                <p>
                                  <span class="noti-span"
                                    >(Supported Format: png,jpg,jpeg,pdf)
                                    <br />(max file size: 10mb)</span
                                  >
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="text-center mt-3"
                        *ngIf="getValue.womenLedStartupsStatus == 3"
                      >
                        <button class="custom-btn btn-12">
                          <span
                            (click)="
                              viewReasonBtn(getValue.womenLedStartupsReason)
                            "
                            >Click!</span
                          ><span>Reason</span>
                        </button>
                      </div>
                    </div>
                    <div
                      class="submitted-details"
                      *ngIf="
                        getValue.womenLedStartupsStatus == 2 ||
                        getValue.womenLedStartupsStatus == 4 ||
                        getValue.womenLedStartupsStatus == 6
                      "
                    >
                      <div class="submiited-header">
                        <div class="name-header d-flex">
                          <span class="material-icons">fact_check</span>
                          <span class="ml-1">Submitted Details :</span>
                        </div>
                      </div>
                      <div class="submitted-content">
                        <div class="sub-div">
                          <p class="p-lbl">
                            Option Selected :
                            <b>{{ getValue.womenLedStartupsIncCentre }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">
                            Percentage of Women-led Startups :
                            <b>{{ getValue.womenledStartupFoundersPercent }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">
                            Total no. of incubated Startups :
                            <b>{{ getValue.womenledStartupFoundersCount }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">Supporting Documents</p>
                          <ul class="sub-ul">
                            <li
                              *ngFor="
                                let list of getValue.womenLedStartupsDocuments
                              "
                            >
                              <a
                                href="{{ list.documentName }}"
                                target="_blank"
                                >{{ list.documentName }}</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div
                          class="sub-div"
                          *ngIf="
                            getValue.womenLedStartupsStatus == 3 ||
                            getValue.womenLedStartupsStatus == 6
                          "
                        >
                          <p class="p-lbl">Reason for clarification</p>
                          <p class="c-black comments">
                            {{ getValue.womenLedStartupsReason }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-12">
                    <div
                      class="guideline-div d-flex"
                      (click)="guidelinesBtn(guidelineValue[0])"
                    >
                      <span class="material-icons">description</span>
                      <span class="ml-1">Guidelines</span>
                    </div>
                  </div>
                </div>
              </div>
              <mat-action-row>
                <button mat-button color="primary" (click)="nextStep()">
                  Save & Continue
                </button>
              </mat-action-row>
            </mat-expansion-panel>
            <!-- qusetion 002 -->
            <mat-expansion-panel [expanded]="step === 1" (opened)="setStep(1)">
              <mat-expansion-panel-header class="d-flex">
                <h6>02.&nbsp;</h6>
                <h6>
                  <span *ngIf="mobileQuery.matches == false">
                    SC / ST Founders with minimum 51% Stake with SC/ST founder
                    or co-founder
                  </span>
                  <span *ngIf="mobileQuery.matches == true">Question</span>
                </h6>
                <div class="success-span ml-auto">
                  <div
                    class="set success"
                    [style.width]="pickWidth(getValue.scstFoundersStatus)"
                    [style.background]="pickColor(getValue.scstFoundersStatus)"
                  >
                    <svg
                      version="1.1"
                      id="check"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 100 100"
                      xml:space="preserve"
                    >
                      <circle
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-miterlimit: 10;
                        "
                        cx="49.799"
                        cy="49.746"
                        r="44.757"
                      />
                      <polyline
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-linecap: round;
                          stroke-linejoin: round;
                          stroke-miterlimit: 10;
                        "
                        points="
                                                        27.114,51 41.402,65.288 72.485,34.205 "
                      />
                    </svg>
                    <span
                      [innerHTML]="innerValue(getValue.scstFoundersStatus)"
                    ></span>
                  </div>
                </div>
              </mat-expansion-panel-header>
              <div class="answer-div">
                <div class="row">
                  <div class="col-12 mb-2" *ngIf="mobileQuery.matches == true">
                    <h6>
                      SC / ST Founders with minimum 51% Stake with SC/ST founder
                      or co-founder
                    </h6>
                  </div>
                  <div class="col-lg-8 col-md-8 col-12">
                    <div
                      *ngIf="
                        getValue.scstFoundersStatus != 2 &&
                        getValue.scstFoundersStatus != 4 &&
                        getValue.scstFoundersStatus != 5 &&
                        getValue.scstFoundersStatus != 6
                      "
                    >
                      <div class="mt-3">
                        <mat-radio-group
                          formControlName="scstFoundersIncCentre"
                          class="example-margin mt-4"
                          aria-label="Select an option"
                          (change)="
                            showOptionstwo(
                              $event.value,
                              '.upload1',
                              1,
                              '.set-succ1'
                            )
                          "
                          [ngClass]="{
                            'is-invalid':
                              setting.scstFoundersIncCentre.touched &&
                              setting.scstFoundersIncCentre.errors
                          }"
                        >
                          <mat-radio-button value="Yes">Yes</mat-radio-button>
                          <mat-radio-button value="No">No</mat-radio-button>
                        </mat-radio-group>
                        <br />
                        <mat-error
                          *ngIf="
                            setting.scstFoundersIncCentre.touched &&
                            setting.scstFoundersIncCentre.errors
                          "
                        >
                          <span
                            *ngIf="
                              setting.scstFoundersIncCentre.errors.required
                            "
                            >Answer is required</span
                          >
                        </mat-error>
                      </div>
                      <div class="opt-div" *ngIf="Optionstwochecked == 'Yes'">
                        <div class="row">
                          <div class="col-lg-6 col-md-6 col-12">
                            <mat-form-field
                              class="material-full-width"
                              appearance="outline"
                            >
                              <mat-label
                                >No of SC/ST Founders
                                <span class="text-danger">*</span></mat-label
                              >
                              <input
                                matInput
                                placeholder="Enter No of SC/ST Founders"
                                (change)="
                                  setStatus($event, 'scstFoundersStatus', 7)
                                "
                                oninput="this.value = this.value.replace(/[^0-9]/g,'')"
                                formControlName="scstStartupFoundersCount"
                                [ngClass]="{
                                  'is-invalid':
                                    setting.scstStartupFoundersCount.touched &&
                                    setting.scstStartupFoundersCount.errors
                                }"
                              />
                              <mat-error
                                *ngIf="
                                  setting.scstStartupFoundersCount.touched &&
                                  setting.scstStartupFoundersCount.errors
                                "
                              >
                                <span
                                  *ngIf="
                                    setting.scstStartupFoundersCount.errors
                                      .required
                                  "
                                  >No of SC/ST Founders is required</span
                                >
                              </mat-error>
                            </mat-form-field>
                          </div>
                          <div class="col-lg-6 col-md-6 col-12">
                            <div class="main-wrapper">
                              <div class="upload-main-wrapper">
                                <div class="upload-wrapper upload1">
                                  <input
                                    type="file"
                                    formControlName="scstFoundersImagefile"
                                    (change)="
                                      fileUpload(
                                        $event,
                                        '.upload1',
                                        1,
                                        '.set-succ1'
                                      )
                                    "
                                    id=""
                                    [ngClass]="{
                                      'is-invalid':
                                        setting.scstFoundersImagefile.touched &&
                                        setting.scstFoundersImagefile.errors
                                    }"
                                  />
                                  <svg
                                    version="1.1"
                                    xmlns="http://www.w3.org/2000/svg"
                                    xmlns:xlink="http://www.w3.org/1999/xlink"
                                    preserveAspectRatio="xMidYMid meet"
                                    viewBox="224.3881704980842 176.8527621722847 221.13266283524905 178.8472378277154"
                                    width="221.13"
                                    height="178.85"
                                  >
                                    <defs>
                                      <path
                                        d="M357.38 176.85C386.18 176.85 409.53 204.24 409.53 238.02C409.53 239.29 409.5 240.56 409.42 241.81C430.23 246.95 445.52 264.16 445.52 284.59C445.52 284.59 445.52 284.59 445.52 284.59C445.52 309.08 423.56 328.94 396.47 328.94C384.17 328.94 285.74 328.94 273.44 328.94C246.35 328.94 224.39 309.08 224.39 284.59C224.39 284.59 224.39 284.59 224.39 284.59C224.39 263.24 241.08 245.41 263.31 241.2C265.3 218.05 281.96 199.98 302.22 199.98C306.67 199.98 310.94 200.85 314.93 202.46C324.4 186.96 339.88 176.85 357.38 176.85Z"
                                        id="b1aO7LLtdW"
                                      ></path>
                                      <path
                                        d="M306.46 297.6L339.79 297.6L373.13 297.6L339.79 255.94L306.46 297.6Z"
                                        id="c4SXvvMdYD"
                                      ></path>
                                      <path
                                        d="M350.79 293.05L328.79 293.05L328.79 355.7L350.79 355.7L350.79 293.05Z"
                                        id="b11si2zUk"
                                      ></path>
                                    </defs>
                                    <g>
                                      <g>
                                        <g>
                                          <use
                                            xlink:href="#b1aO7LLtdW"
                                            opacity="1"
                                            fill="#ffffff"
                                            fill-opacity="1"
                                          ></use>
                                        </g>
                                        <g>
                                          <g>
                                            <use
                                              xlink:href="#c4SXvvMdYD"
                                              opacity="1"
                                              fill="#363535"
                                              fill-opacity="1"
                                            ></use>
                                          </g>
                                          <g>
                                            <use
                                              xlink:href="#b11si2zUk"
                                              opacity="1"
                                              fill="#363535"
                                              fill-opacity="1"
                                            ></use>
                                          </g>
                                        </g>
                                      </g>
                                    </g>
                                  </svg>
                                  <span class="file-upload-text"
                                    >Upload Documentary</span
                                  >
                                  <div class="file-success-text">
                                    <svg
                                      version="1.1"
                                      id="check"
                                      xmlns="http://www.w3.org/2000/svg"
                                      xmlns:xlink="http://www.w3.org/1999/xlink"
                                      x="0px"
                                      y="0px"
                                      viewBox="0 0 100 100"
                                      xml:space="preserve"
                                    >
                                      <circle
                                        style="
                                          fill: rgba(0, 0, 0, 0);
                                          stroke: #ffffff;
                                          stroke-width: 10;
                                          stroke-miterlimit: 10;
                                        "
                                        cx="49.799"
                                        cy="49.746"
                                        r="44.757"
                                      />
                                      <polyline
                                        style="
                                          fill: rgba(0, 0, 0, 0);
                                          stroke: #ffffff;
                                          stroke-width: 10;
                                          stroke-linecap: round;
                                          stroke-linejoin: round;
                                          stroke-miterlimit: 10;
                                        "
                                        points="
                                27.114,51 41.402,65.288 72.485,34.205 "
                                      />
                                    </svg>
                                    <span>Uploading</span>
                                  </div>
                                </div>
                                <mat-error
                                  *ngIf="
                                    setting.scstFoundersImagefile.touched &&
                                    setting.scstFoundersImagefile.errors
                                  "
                                >
                                  <span
                                    *ngIf="
                                      setting.scstFoundersImagefile.errors
                                        .required
                                    "
                                    >Documentary is required</span
                                  >
                                </mat-error>
                                <div
                                  class="remove-wrapper upload1"
                                  (click)="
                                    removeFile('.upload1', 1, '.set-succ1')
                                  "
                                >
                                  <div class="file-success-text">
                                    <ion-icon
                                      name="close-circle-outline"
                                    ></ion-icon
                                    ><span>Remove Documentary</span>
                                  </div>
                                </div>
                                <p>
                                  <span class="noti-span"
                                    >(Supported Format: png,jpg,jpeg,pdf)
                                    <br />(max file size: 10mb)</span
                                  >
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="text-center mt-3"
                        *ngIf="getValue.scstFoundersStatus == 3"
                      >
                        <button class="custom-btn btn-12">
                          <span
                            (click)="viewReasonBtn(getValue.scstFoundersReason)"
                            >Click!</span
                          ><span>Reason</span>
                        </button>
                      </div>
                    </div>
                    <div
                      class="submitted-details"
                      *ngIf="
                        getValue.scstFoundersStatus == 2 ||
                        getValue.scstFoundersStatus == 4 ||
                        getValue.scstFoundersStatus == 6
                      "
                    >
                      <div class="submiited-header">
                        <div class="name-header d-flex">
                          <span class="material-icons">fact_check</span>
                          <span class="ml-1">Submitted Details :</span>
                        </div>
                      </div>
                      <div class="submitted-content">
                        <div class="sub-div">
                          <p class="p-lbl">
                            Option Selected :
                            <b>{{ getValue.scstFoundersIncCentre }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">
                            No of SC/ST Founders :
                            <b>{{ getValue.scstStartupFoundersCount }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">Supporting Documents</p>
                          <ul class="sub-ul">
                            <li
                              *ngFor="
                                let list of getValue.scstFoundersDocuments
                              "
                            >
                              <a
                                href="{{ list.documentName }}"
                                target="_blank"
                                >{{ list.documentName }}</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div
                          class="sub-div"
                          *ngIf="
                            getValue.scstFoundersStatus == 3 ||
                            getValue.scstFoundersStatus == 6
                          "
                        >
                          <p class="p-lbl">Reason for clarification</p>
                          <p class="c-black comments">
                            {{ getValue.scstFoundersReason }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-12">
                    <div
                      class="guideline-div d-flex"
                      (click)="guidelinesBtn(guidelineValue[1])"
                    >
                      <span class="material-icons">description</span>
                      <span class="ml-1">Guidelines</span>
                    </div>
                  </div>
                </div>
              </div>
              <mat-action-row>
                <button mat-button color="warn" (click)="prevStep()">
                  Previous
                </button>
                <button mat-button color="primary" (click)="nextStep()">
                  Save & Continue
                </button>
              </mat-action-row>
            </mat-expansion-panel>
            <!-- qusetion 003 -->
            <mat-expansion-panel [expanded]="step === 2" (opened)="setStep(2)">
              <mat-expansion-panel-header class="d-flex">
                <h6>03.&nbsp;</h6>
                <h6>
                  <span *ngIf="mobileQuery.matches == false">
                    Programs on Circular Economy / Rural Impact Startups /
                    Alternate Livelihood
                  </span>
                  <span *ngIf="mobileQuery.matches == true">Question</span>
                </h6>
                <div class="success-span ml-auto">
                  <div
                    class="set success"
                    [style.width]="pickWidth(getValue.programsOnCircularStatus)"
                    [style.background]="
                      pickColor(getValue.programsOnCircularStatus)
                    "
                  >
                    <svg
                      version="1.1"
                      id="check"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 100 100"
                      xml:space="preserve"
                    >
                      <circle
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-miterlimit: 10;
                        "
                        cx="49.799"
                        cy="49.746"
                        r="44.757"
                      />
                      <polyline
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-linecap: round;
                          stroke-linejoin: round;
                          stroke-miterlimit: 10;
                        "
                        points="
                                                27.114,51 41.402,65.288 72.485,34.205 "
                      />
                    </svg>
                    <span
                      [innerHTML]="
                        innerValue(getValue.programsOnCircularStatus)
                      "
                    ></span>
                  </div>
                </div>
              </mat-expansion-panel-header>
              <div class="answer-div">
                <div class="row">
                  <div class="col-12 mb-2" *ngIf="mobileQuery.matches == true">
                    <h6>
                      Programs on Circular Economy / Rural Impact Startups /
                      Alternate Livelihood
                    </h6>
                  </div>
                  <div class="col-lg-8 col-md-8 col-12">
                    <div
                      *ngIf="
                        getValue.programsOnCircularStatus != 2 &&
                        getValue.programsOnCircularStatus != 4 &&
                        getValue.programsOnCircularStatus != 5 &&
                        getValue.programsOnCircularStatus != 6
                      "
                    >
                      <div class="mt-3">
                        <mat-radio-group
                          formControlName="programsOnCircularPresent"
                          class="example-margin mt-4"
                          aria-label="Select an option"
                          (change)="
                            showOptions11(
                              $event.value,
                              '.upload9',
                              9,
                              '.set-succ9'
                            )
                          "
                          [ngClass]="{
                            'is-invalid':
                              setting.programsOnCircularPresent.touched &&
                              setting.programsOnCircularPresent.errors
                          }"
                        >
                          <mat-radio-button value="Yes">Yes</mat-radio-button>
                          <mat-radio-button value="No">No</mat-radio-button>
                        </mat-radio-group>
                        <br />
                        <mat-error
                          *ngIf="
                            setting.programsOnCircularPresent.touched &&
                            setting.programsOnCircularPresent.errors
                          "
                        >
                          <span
                            *ngIf="
                              setting.programsOnCircularPresent.errors.required
                            "
                            >Answer is required</span
                          >
                        </mat-error>
                      </div>
                      <div class="opt-div" *ngIf="Options11checked == 'Yes'">
                        <div class="row">
                          <div class="col-lg-6 col-md-6 col-12">
                            <mat-form-field
                              class="material-full-width"
                              appearance="outline"
                            >
                              <mat-label
                                >No. of Programs<span class="text-danger"
                                  >*</span
                                ></mat-label
                              >
                              <input
                                matInput
                                placeholder="Enter No. of Programs"
                                (change)="
                                  setStatus(
                                    $event,
                                    'programsOnCircularStatus',
                                    7
                                  )
                                "
                                oninput="this.value = this.value.replace(/[^0-9]/g,'')"
                                formControlName="programsOnCircularNoOfPrograms"
                                [ngClass]="{
                                  'is-invalid':
                                    setting.programsOnCircularNoOfPrograms
                                      .touched &&
                                    setting.programsOnCircularNoOfPrograms
                                      .errors
                                }"
                              />
                              <mat-error
                                *ngIf="
                                  setting.programsOnCircularNoOfPrograms
                                    .touched &&
                                  setting.programsOnCircularNoOfPrograms.errors
                                "
                              >
                                <span
                                  *ngIf="
                                    setting.programsOnCircularNoOfPrograms
                                      .errors.required
                                  "
                                  >No. of Programs is required</span
                                >
                              </mat-error>
                            </mat-form-field>
                          </div>
                          <div class="col-lg-6 col-md-6 col-12">
                            <div class="main-wrapper">
                              <div class="upload-main-wrapper">
                                <div class="upload-wrapper upload9">
                                  <input
                                    type="file"
                                    formControlName="programsOnCircularImagefile"
                                    (change)="
                                      fileUpload(
                                        $event,
                                        '.upload9',
                                        9,
                                        '.set-succ9'
                                      )
                                    "
                                    accept=".pdf,.jpeg,.png,.jpg"
                                    id=""
                                    [ngClass]="{
                                      'is-invalid':
                                        setting.programsOnCircularImagefile
                                          .touched &&
                                        setting.programsOnCircularImagefile
                                          .errors
                                    }"
                                  />
                                  <svg
                                    version="1.1"
                                    xmlns="http://www.w3.org/2000/svg"
                                    xmlns:xlink="http://www.w3.org/1999/xlink"
                                    preserveAspectRatio="xMidYMid meet"
                                    viewBox="224.3881704980842 176.8527621722847 221.13266283524905 178.8472378277154"
                                    width="221.13"
                                    height="178.85"
                                  >
                                    <defs>
                                      <path
                                        d="M357.38 176.85C386.18 176.85 409.53 204.24 409.53 238.02C409.53 239.29 409.5 240.56 409.42 241.81C430.23 246.95 445.52 264.16 445.52 284.59C445.52 284.59 445.52 284.59 445.52 284.59C445.52 309.08 423.56 328.94 396.47 328.94C384.17 328.94 285.74 328.94 273.44 328.94C246.35 328.94 224.39 309.08 224.39 284.59C224.39 284.59 224.39 284.59 224.39 284.59C224.39 263.24 241.08 245.41 263.31 241.2C265.3 218.05 281.96 199.98 302.22 199.98C306.67 199.98 310.94 200.85 314.93 202.46C324.4 186.96 339.88 176.85 357.38 176.85Z"
                                        id="b1aO7LLtdW"
                                      ></path>
                                      <path
                                        d="M306.46 297.6L339.79 297.6L373.13 297.6L339.79 255.94L306.46 297.6Z"
                                        id="c4SXvvMdYD"
                                      ></path>
                                      <path
                                        d="M350.79 293.05L328.79 293.05L328.79 355.7L350.79 355.7L350.79 293.05Z"
                                        id="b11si2zUk"
                                      ></path>
                                    </defs>
                                    <g>
                                      <g>
                                        <g>
                                          <use
                                            xlink:href="#b1aO7LLtdW"
                                            opacity="1"
                                            fill="#ffffff"
                                            fill-opacity="1"
                                          ></use>
                                        </g>
                                        <g>
                                          <g>
                                            <use
                                              xlink:href="#c4SXvvMdYD"
                                              opacity="1"
                                              fill="#363535"
                                              fill-opacity="1"
                                            ></use>
                                          </g>
                                          <g>
                                            <use
                                              xlink:href="#b11si2zUk"
                                              opacity="1"
                                              fill="#363535"
                                              fill-opacity="1"
                                            ></use>
                                          </g>
                                        </g>
                                      </g>
                                    </g>
                                  </svg>
                                  <span class="file-upload-text"
                                    >Upload Documentary</span
                                  >
                                  <div class="file-success-text">
                                    <svg
                                      version="1.1"
                                      id="check"
                                      xmlns="http://www.w3.org/2000/svg"
                                      xmlns:xlink="http://www.w3.org/1999/xlink"
                                      x="0px"
                                      y="0px"
                                      viewBox="0 0 100 100"
                                      xml:space="preserve"
                                    >
                                      <circle
                                        style="
                                          fill: rgba(0, 0, 0, 0);
                                          stroke: #ffffff;
                                          stroke-width: 10;
                                          stroke-miterlimit: 10;
                                        "
                                        cx="49.799"
                                        cy="49.746"
                                        r="44.757"
                                      />
                                      <polyline
                                        style="
                                          fill: rgba(0, 0, 0, 0);
                                          stroke: #ffffff;
                                          stroke-width: 10;
                                          stroke-linecap: round;
                                          stroke-linejoin: round;
                                          stroke-miterlimit: 10;
                                        "
                                        points="
                                                                        27.114,51 41.402,65.288 72.485,34.205 "
                                      />
                                    </svg>
                                    <span>Uploading</span>
                                  </div>
                                </div>
                                <mat-error
                                  *ngIf="
                                    setting.programsOnCircularImagefile
                                      .touched &&
                                    setting.programsOnCircularImagefile.errors
                                  "
                                >
                                  <span
                                    *ngIf="
                                      setting.programsOnCircularImagefile.errors
                                        .required
                                    "
                                    >Documentary is required</span
                                  >
                                </mat-error>
                                <div
                                  class="remove-wrapper upload9"
                                  (click)="
                                    removeFile('.upload9', 9, '.set-succ9')
                                  "
                                >
                                  <div class="file-success-text">
                                    <ion-icon
                                      name="close-circle-outline"
                                    ></ion-icon
                                    ><span>Remove Documentary</span>
                                  </div>
                                </div>
                                <p>
                                  <span class="noti-span"
                                    >(Supported Format: png,jpg,jpeg,pdf)
                                    <br />(max file size: 10mb)</span
                                  >
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="text-center mt-3"
                        *ngIf="getValue.programsOnCircularStatus == 3"
                      >
                        <button class="custom-btn btn-12">
                          <span
                            (click)="
                              viewReasonBtn(getValue.programsOnCircularReason)
                            "
                            >Click!</span
                          ><span>Reason</span>
                        </button>
                      </div>
                    </div>
                    <div
                      class="submitted-details"
                      *ngIf="
                        getValue.programsOnCircularStatus == 2 ||
                        getValue.programsOnCircularStatus == 4 ||
                        getValue.programsOnCircularStatus == 6
                      "
                    >
                      <div class="submiited-header">
                        <div class="name-header d-flex">
                          <span class="material-icons">fact_check</span>
                          <span class="ml-1">Submitted Details :</span>
                        </div>
                      </div>
                      <div class="submitted-content">
                        <div class="sub-div">
                          <p class="p-lbl">
                            Option Selected :
                            <b>{{ getValue.programsOnCircularPresent }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">
                            No of Startups :
                            <b>{{ getValue.programsOnCircularNoOfPrograms }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">Supporting Documents</p>
                          <ul class="sub-ul">
                            <li
                              *ngFor="
                                let list of getValue.programsOnCircularDocuments
                              "
                            >
                              <a
                                href="{{ list.documentName }}"
                                target="_blank"
                                >{{ list.documentName }}</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div
                          class="sub-div"
                          *ngIf="
                            getValue.programsOnCircularStatus == 3 ||
                            getValue.programsOnCircularStatus == 6
                          "
                        >
                          <p class="p-lbl">Reason for clarification</p>
                          <p class="c-black comments">
                            {{ getValue.programsOnCircularReason }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-12">
                    <div
                      class="guideline-div d-flex"
                      (click)="guidelinesBtn(guidelineValue[2])"
                    >
                      <span class="material-icons">description</span>
                      <span class="ml-1">Guidelines</span>
                    </div>
                  </div>
                </div>
              </div>
              <mat-action-row>
                <button mat-button color="warn" (click)="prevStep()">
                  Previous
                </button>
                <button mat-button color="primary" (click)="nextStep()">
                  Save & Continue
                </button>
              </mat-action-row>
            </mat-expansion-panel>
            <!-- qusetion 004 -->
            <mat-expansion-panel [expanded]="step === 3" (opened)="setStep(3)">
              <mat-expansion-panel-header class="d-flex">
                <h6>04.&nbsp;</h6>
                <h6>
                  <span *ngIf="mobileQuery.matches == false">
                    Startups working on Environmental Sustainability / Electric
                    Vehicles / Climate Resilience / SDG goals / Renewable Energy
                  </span>
                  <span *ngIf="mobileQuery.matches == true">Question</span>
                </h6>
                <div class="success-span ml-auto">
                  <div
                    class="set success"
                    [style.width]="
                      pickWidth(getValue.environmentalSustainabilityStatus)
                    "
                    [style.background]="
                      pickColor(getValue.environmentalSustainabilityStatus)
                    "
                  >
                    <svg
                      version="1.1"
                      id="check"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 100 100"
                      xml:space="preserve"
                    >
                      <circle
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-miterlimit: 10;
                        "
                        cx="49.799"
                        cy="49.746"
                        r="44.757"
                      />
                      <polyline
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-linecap: round;
                          stroke-linejoin: round;
                          stroke-miterlimit: 10;
                        "
                        points="
                                                27.114,51 41.402,65.288 72.485,34.205 "
                      />
                    </svg>
                    <span
                      [innerHTML]="
                        innerValue(getValue.environmentalSustainabilityStatus)
                      "
                    ></span>
                  </div>
                </div>
              </mat-expansion-panel-header>
              <div class="answer-div">
                <div class="row">
                  <div class="col-12 mb-2" *ngIf="mobileQuery.matches == true">
                    <h6>
                      Startups working on Environmental Sustainability /
                      Electric Vehicles / Climate Resilience / SDG goals /
                      Renewable Energy
                    </h6>
                  </div>
                  <div class="col-lg-8 col-md-8 col-12">
                    <div
                      *ngIf="
                        getValue.environmentalSustainabilityStatus != 2 &&
                        getValue.environmentalSustainabilityStatus != 4 &&
                        getValue.environmentalSustainabilityStatus != 5 &&
                        getValue.environmentalSustainabilityStatus != 6
                      "
                    >
                      <div class="mt-3">
                        <mat-radio-group
                          formControlName="environmentalSustainabilityIncCentre"
                          class="example-margin mt-4"
                          aria-label="Select an option"
                          (change)="
                            showOptionsthree(
                              $event.value,
                              '.upload2',
                              2,
                              '.set-succ2'
                            )
                          "
                          [ngClass]="{
                            'is-invalid':
                              setting.environmentalSustainabilityIncCentre
                                .touched &&
                              setting.environmentalSustainabilityIncCentre
                                .errors
                          }"
                        >
                          <mat-radio-button value="Yes">Yes</mat-radio-button>
                          <mat-radio-button value="No">No</mat-radio-button>
                        </mat-radio-group>
                        <br />
                        <mat-error
                          *ngIf="
                            setting.environmentalSustainabilityIncCentre
                              .touched &&
                            setting.environmentalSustainabilityIncCentre.errors
                          "
                        >
                          <span
                            *ngIf="
                              setting.environmentalSustainabilityIncCentre
                                .errors.required
                            "
                            >Answer is required</span
                          >
                        </mat-error>
                      </div>
                      <div class="opt-div" *ngIf="Optionsthreechecked == 'Yes'">
                        <div class="row">
                          <div class="col-lg-6 col-md-6 col-12">
                            <mat-form-field
                              class="material-full-width"
                              appearance="outline"
                            >
                              <mat-label
                                >No of Startups
                                <span class="text-danger">*</span></mat-label
                              >
                              <input
                                matInput
                                placeholder="Enter No of Startups"
                                (change)="
                                  setStatus(
                                    $event,
                                    'environmentalSustainabilityStatus',
                                    7
                                  )
                                "
                                oninput="this.value = this.value.replace(/[^0-9]/g,'')"
                                formControlName="environmentalSustainabilityNoOfStartup"
                                [ngClass]="{
                                  'is-invalid':
                                    setting
                                      .environmentalSustainabilityNoOfStartup
                                      .touched &&
                                    setting
                                      .environmentalSustainabilityNoOfStartup
                                      .errors
                                }"
                              />
                              <mat-error
                                *ngIf="
                                  setting.environmentalSustainabilityNoOfStartup
                                    .touched &&
                                  setting.environmentalSustainabilityNoOfStartup
                                    .errors
                                "
                              >
                                <span
                                  *ngIf="
                                    setting
                                      .environmentalSustainabilityNoOfStartup
                                      .errors.required
                                  "
                                  >No of Startup is required</span
                                >
                              </mat-error>
                            </mat-form-field>
                          </div>
                          <div class="col-lg-6 col-md-6 col-12">
                            <div class="main-wrapper">
                              <div class="upload-main-wrapper">
                                <div class="upload-wrapper upload2">
                                  <input
                                    type="file"
                                    formControlName="environmentalSustainabilityImagefile"
                                    (change)="
                                      fileUpload(
                                        $event,
                                        '.upload2',
                                        2,
                                        '.set-succ2'
                                      )
                                    "
                                    accept=".pdf,.jpeg,.png,.jpg"
                                    id=""
                                    [ngClass]="{
                                      'is-invalid':
                                        setting
                                          .environmentalSustainabilityImagefile
                                          .touched &&
                                        setting
                                          .environmentalSustainabilityImagefile
                                          .errors
                                    }"
                                  />
                                  <svg
                                    version="1.1"
                                    xmlns="http://www.w3.org/2000/svg"
                                    xmlns:xlink="http://www.w3.org/1999/xlink"
                                    preserveAspectRatio="xMidYMid meet"
                                    viewBox="224.3881704980842 176.8527621722847 221.13266283524905 178.8472378277154"
                                    width="221.13"
                                    height="178.85"
                                  >
                                    <defs>
                                      <path
                                        d="M357.38 176.85C386.18 176.85 409.53 204.24 409.53 238.02C409.53 239.29 409.5 240.56 409.42 241.81C430.23 246.95 445.52 264.16 445.52 284.59C445.52 284.59 445.52 284.59 445.52 284.59C445.52 309.08 423.56 328.94 396.47 328.94C384.17 328.94 285.74 328.94 273.44 328.94C246.35 328.94 224.39 309.08 224.39 284.59C224.39 284.59 224.39 284.59 224.39 284.59C224.39 263.24 241.08 245.41 263.31 241.2C265.3 218.05 281.96 199.98 302.22 199.98C306.67 199.98 310.94 200.85 314.93 202.46C324.4 186.96 339.88 176.85 357.38 176.85Z"
                                        id="b1aO7LLtdW"
                                      ></path>
                                      <path
                                        d="M306.46 297.6L339.79 297.6L373.13 297.6L339.79 255.94L306.46 297.6Z"
                                        id="c4SXvvMdYD"
                                      ></path>
                                      <path
                                        d="M350.79 293.05L328.79 293.05L328.79 355.7L350.79 355.7L350.79 293.05Z"
                                        id="b11si2zUk"
                                      ></path>
                                    </defs>
                                    <g>
                                      <g>
                                        <g>
                                          <use
                                            xlink:href="#b1aO7LLtdW"
                                            opacity="1"
                                            fill="#ffffff"
                                            fill-opacity="1"
                                          ></use>
                                        </g>
                                        <g>
                                          <g>
                                            <use
                                              xlink:href="#c4SXvvMdYD"
                                              opacity="1"
                                              fill="#363535"
                                              fill-opacity="1"
                                            ></use>
                                          </g>
                                          <g>
                                            <use
                                              xlink:href="#b11si2zUk"
                                              opacity="1"
                                              fill="#363535"
                                              fill-opacity="1"
                                            ></use>
                                          </g>
                                        </g>
                                      </g>
                                    </g>
                                  </svg>
                                  <span class="file-upload-text"
                                    >Upload Documentary</span
                                  >
                                  <div class="file-success-text">
                                    <svg
                                      version="1.1"
                                      id="check"
                                      xmlns="http://www.w3.org/2000/svg"
                                      xmlns:xlink="http://www.w3.org/1999/xlink"
                                      x="0px"
                                      y="0px"
                                      viewBox="0 0 100 100"
                                      xml:space="preserve"
                                    >
                                      <circle
                                        style="
                                          fill: rgba(0, 0, 0, 0);
                                          stroke: #ffffff;
                                          stroke-width: 10;
                                          stroke-miterlimit: 10;
                                        "
                                        cx="49.799"
                                        cy="49.746"
                                        r="44.757"
                                      />
                                      <polyline
                                        style="
                                          fill: rgba(0, 0, 0, 0);
                                          stroke: #ffffff;
                                          stroke-width: 10;
                                          stroke-linecap: round;
                                          stroke-linejoin: round;
                                          stroke-miterlimit: 10;
                                        "
                                        points="
                                                                        27.114,51 41.402,65.288 72.485,34.205 "
                                      />
                                    </svg>
                                    <span>Uploading</span>
                                  </div>
                                </div>
                                <mat-error
                                  *ngIf="
                                    setting.environmentalSustainabilityImagefile
                                      .touched &&
                                    setting.environmentalSustainabilityImagefile
                                      .errors
                                  "
                                >
                                  <span
                                    *ngIf="
                                      setting
                                        .environmentalSustainabilityImagefile
                                        .errors.required
                                    "
                                    >Documentary is required</span
                                  >
                                </mat-error>
                                <div
                                  class="remove-wrapper upload2"
                                  (click)="
                                    removeFile('.upload2', 2, '.set-succ2')
                                  "
                                >
                                  <div class="file-success-text">
                                    <ion-icon
                                      name="close-circle-outline"
                                    ></ion-icon
                                    ><span>Remove Documentary</span>
                                  </div>
                                </div>
                                <p>
                                  <span class="noti-span"
                                    >(Supported Format: png,jpg,jpeg,pdf)
                                    <br />(max file size: 10mb)</span
                                  >
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="text-center mt-3"
                        *ngIf="getValue.environmentalSustainabilityStatus == 3"
                      >
                        <button class="custom-btn btn-12">
                          <span
                            (click)="
                              viewReasonBtn(
                                getValue.environmentalSustainabilityReason
                              )
                            "
                            >Click!</span
                          ><span>Reason</span>
                        </button>
                      </div>
                    </div>
                    <div
                      class="submitted-details"
                      *ngIf="
                        getValue.environmentalSustainabilityStatus == 2 ||
                        getValue.environmentalSustainabilityStatus == 4 ||
                        getValue.environmentalSustainabilityStatus == 6
                      "
                    >
                      <div class="submiited-header">
                        <div class="name-header d-flex">
                          <span class="material-icons">fact_check</span>
                          <span class="ml-1">Submitted Details :</span>
                        </div>
                      </div>
                      <div class="submitted-content">
                        <div class="sub-div">
                          <p class="p-lbl">
                            Option Selected :
                            <b>{{
                              getValue.environmentalSustainabilityIncCentre
                            }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">
                            No of Startups :
                            <b>{{
                              getValue.environmentalSustainabilityNoOfStartup
                            }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">Supporting Documents</p>
                          <ul class="sub-ul">
                            <li
                              *ngFor="
                                let list of getValue.environmentalSustainabilityDocuments
                              "
                            >
                              <a
                                href="{{ list.documentName }}"
                                target="_blank"
                                >{{ list.documentName }}</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div
                          class="sub-div"
                          *ngIf="
                            getValue.environmentalSustainabilityStatus == 3 ||
                            getValue.environmentalSustainabilityStatus == 6
                          "
                        >
                          <p class="p-lbl">Reason for clarification</p>
                          <p class="c-black comments">
                            {{ getValue.environmentalSustainabilityReason }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-12">
                    <div
                      class="guideline-div d-flex"
                      (click)="guidelinesBtn(guidelineValue[3])"
                    >
                      <span class="material-icons">description</span>
                      <span class="ml-1">Guidelines</span>
                    </div>
                  </div>
                </div>
              </div>
              <mat-action-row>
                <button mat-button color="warn" (click)="prevStep()">
                  Previous
                </button>
                <button mat-button color="primary" (click)="nextStep()">
                  Save & Continue
                </button>
              </mat-action-row>
            </mat-expansion-panel>
            <!-- qusetion 005 -->
            <mat-expansion-panel [expanded]="step === 4" (opened)="setStep(4)">
              <mat-expansion-panel-header class="d-flex">
                <h6>05.&nbsp;</h6>
                <h6>
                  <span *ngIf="mobileQuery.matches == false">
                    Funding facilitated for Startups by Women / SC&ST /
                    Transperson Incubatees
                  </span>
                  <span *ngIf="mobileQuery.matches == true">Question</span>
                </h6>
                <div class="success-span ml-auto">
                  <div
                    class="set success"
                    [style.width]="
                      pickWidth(getValue.fundFacilitatedForStartupStatus)
                    "
                    [style.background]="
                      pickColor(getValue.fundFacilitatedForStartupStatus)
                    "
                  >
                    <svg
                      version="1.1"
                      id="check"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 100 100"
                      xml:space="preserve"
                    >
                      <circle
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-miterlimit: 10;
                        "
                        cx="49.799"
                        cy="49.746"
                        r="44.757"
                      />
                      <polyline
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-linecap: round;
                          stroke-linejoin: round;
                          stroke-miterlimit: 10;
                        "
                        points="
                                                    27.114,51 41.402,65.288 72.485,34.205 "
                      />
                    </svg>
                    <span
                      [innerHTML]="
                        innerValue(getValue.fundFacilitatedForStartupStatus)
                      "
                    ></span>
                  </div>
                </div>
              </mat-expansion-panel-header>
              <div class="answer-div">
                <div class="row">
                  <div class="col-12 mb-2" *ngIf="mobileQuery.matches == true">
                    <h6>
                      Funding facilitated for Startups by Women / SC&ST /
                      Transperson Incubatees
                    </h6>
                  </div>
                  <div class="col-lg-8 col-md-8 col-12">
                    <div
                      *ngIf="
                        getValue.fundFacilitatedForStartupStatus != 2 &&
                        getValue.fundFacilitatedForStartupStatus != 4 &&
                        getValue.fundFacilitatedForStartupStatus != 5 &&
                        getValue.fundFacilitatedForStartupStatus != 6
                      "
                    >
                      <div class="mt-3">
                        <mat-radio-group
                          formControlName="fundFacilitatedForStartupPresent"
                          class="example-margin mt-4"
                          aria-label="Select an option"
                          (change)="
                            showOptions12(
                              $event.value,
                              '.10',
                              10,
                              '.set-succ10'
                            )
                          "
                          [ngClass]="{
                            'is-invalid':
                              setting.fundFacilitatedForStartupPresent
                                .touched &&
                              setting.fundFacilitatedForStartupPresent.errors
                          }"
                        >
                          <mat-radio-button value="Yes">Yes</mat-radio-button>
                          <mat-radio-button value="No">No</mat-radio-button>
                        </mat-radio-group>
                        <br />
                        <mat-error
                          *ngIf="
                            setting.fundFacilitatedForStartupPresent.touched &&
                            setting.fundFacilitatedForStartupPresent.errors
                          "
                        >
                          <span
                            *ngIf="
                              setting.fundFacilitatedForStartupPresent.errors
                                .required
                            "
                            >Answer is required</span
                          >
                        </mat-error>
                      </div>
                      <div class="opt-div" *ngIf="Options12checked == 'Yes'">
                        <div class="row">
                          <div class="col-lg-6 col-md-6 col-12">
                            <mat-form-field
                              class="material-full-width"
                              appearance="outline"
                            >
                              <mat-label
                                >No. of Startups
                                <span class="text-danger">*</span></mat-label
                              >
                              <input
                                matInput
                                placeholder="Enter No. of Startups "
                                (change)="
                                  setStatus(
                                    $event,
                                    'fundFacilitatedForStartupStatus',
                                    7
                                  )
                                "
                                oninput="this.value = this.value.replace(/[^0-9]/g,'')"
                                formControlName="fundFacilitatedForStartupNoOfStartup"
                                [ngClass]="{
                                  'is-invalid':
                                    setting.fundFacilitatedForStartupNoOfStartup
                                      .touched &&
                                    setting.fundFacilitatedForStartupNoOfStartup
                                      .errors
                                }"
                              />
                              <mat-error
                                *ngIf="
                                  setting.fundFacilitatedForStartupNoOfStartup
                                    .touched &&
                                  setting.fundFacilitatedForStartupNoOfStartup
                                    .errors
                                "
                              >
                                <span
                                  *ngIf="
                                    setting.fundFacilitatedForStartupNoOfStartup
                                      .errors.required
                                  "
                                  >No. of Startups required</span
                                >
                              </mat-error>
                            </mat-form-field>
                          </div>
                          <div class="col-lg-6 col-md-6 col-12">
                            <div class="main-wrapper">
                              <div class="upload-main-wrapper">
                                <div class="upload-wrapper upload10">
                                  <input
                                    type="file"
                                    formControlName="fundFacilitatedForStartupImagefile"
                                    (change)="
                                      fileUpload(
                                        $event,
                                        '.upload10',
                                        10,
                                        '.set-succ10'
                                      )
                                    "
                                    accept=".pdf,.jpeg,.png,.jpg"
                                    id=""
                                    [ngClass]="{
                                      'is-invalid':
                                        setting
                                          .fundFacilitatedForStartupImagefile
                                          .touched &&
                                        setting
                                          .fundFacilitatedForStartupImagefile
                                          .errors
                                    }"
                                  />
                                  <svg
                                    version="1.1"
                                    xmlns="http://www.w3.org/2000/svg"
                                    xmlns:xlink="http://www.w3.org/1999/xlink"
                                    preserveAspectRatio="xMidYMid meet"
                                    viewBox="224.3881704980842 176.8527621722847 221.13266283524905 178.8472378277154"
                                    width="221.13"
                                    height="178.85"
                                  >
                                    <defs>
                                      <path
                                        d="M357.38 176.85C386.18 176.85 409.53 204.24 409.53 238.02C409.53 239.29 409.5 240.56 409.42 241.81C430.23 246.95 445.52 264.16 445.52 284.59C445.52 284.59 445.52 284.59 445.52 284.59C445.52 309.08 423.56 328.94 396.47 328.94C384.17 328.94 285.74 328.94 273.44 328.94C246.35 328.94 224.39 309.08 224.39 284.59C224.39 284.59 224.39 284.59 224.39 284.59C224.39 263.24 241.08 245.41 263.31 241.2C265.3 218.05 281.96 199.98 302.22 199.98C306.67 199.98 310.94 200.85 314.93 202.46C324.4 186.96 339.88 176.85 357.38 176.85Z"
                                        id="b1aO7LLtdW"
                                      ></path>
                                      <path
                                        d="M306.46 297.6L339.79 297.6L373.13 297.6L339.79 255.94L306.46 297.6Z"
                                        id="c4SXvvMdYD"
                                      ></path>
                                      <path
                                        d="M350.79 293.05L328.79 293.05L328.79 355.7L350.79 355.7L350.79 293.05Z"
                                        id="b11si2zUk"
                                      ></path>
                                    </defs>
                                    <g>
                                      <g>
                                        <g>
                                          <use
                                            xlink:href="#b1aO7LLtdW"
                                            opacity="1"
                                            fill="#ffffff"
                                            fill-opacity="1"
                                          ></use>
                                        </g>
                                        <g>
                                          <g>
                                            <use
                                              xlink:href="#c4SXvvMdYD"
                                              opacity="1"
                                              fill="#363535"
                                              fill-opacity="1"
                                            ></use>
                                          </g>
                                          <g>
                                            <use
                                              xlink:href="#b11si2zUk"
                                              opacity="1"
                                              fill="#363535"
                                              fill-opacity="1"
                                            ></use>
                                          </g>
                                        </g>
                                      </g>
                                    </g>
                                  </svg>
                                  <span class="file-upload-text"
                                    >Upload Documentary</span
                                  >
                                  <div class="file-success-text">
                                    <svg
                                      version="1.1"
                                      id="check"
                                      xmlns="http://www.w3.org/2000/svg"
                                      xmlns:xlink="http://www.w3.org/1999/xlink"
                                      x="0px"
                                      y="0px"
                                      viewBox="0 0 100 100"
                                      xml:space="preserve"
                                    >
                                      <circle
                                        style="
                                          fill: rgba(0, 0, 0, 0);
                                          stroke: #ffffff;
                                          stroke-width: 10;
                                          stroke-miterlimit: 10;
                                        "
                                        cx="49.799"
                                        cy="49.746"
                                        r="44.757"
                                      />
                                      <polyline
                                        style="
                                          fill: rgba(0, 0, 0, 0);
                                          stroke: #ffffff;
                                          stroke-width: 10;
                                          stroke-linecap: round;
                                          stroke-linejoin: round;
                                          stroke-miterlimit: 10;
                                        "
                                        points="
                                27.114,51 41.402,65.288 72.485,34.205 "
                                      />
                                    </svg>
                                    <span>Uploading</span>
                                  </div>
                                </div>
                                <mat-error
                                  *ngIf="
                                    setting.fundFacilitatedForStartupImagefile
                                      .touched &&
                                    setting.fundFacilitatedForStartupImagefile
                                      .errors
                                  "
                                >
                                  <span
                                    *ngIf="
                                      setting.fundFacilitatedForStartupImagefile
                                        .errors.required
                                    "
                                    >Documentary is required</span
                                  >
                                </mat-error>
                                <div
                                  class="remove-wrapper upload10"
                                  (click)="
                                    removeFile('.upload10', 10, '.set-succ10')
                                  "
                                >
                                  <div class="file-success-text">
                                    <ion-icon
                                      name="close-circle-outline"
                                    ></ion-icon
                                    ><span>Remove Documentary</span>
                                  </div>
                                </div>
                                <p>
                                  <span class="noti-span"
                                    >(Supported Format: png,jpg,jpeg,pdf)
                                    <br />(max file size: 10mb)</span
                                  >
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="text-center mt-3"
                        *ngIf="getValue.fundFacilitatedForStartupStatus == 3"
                      >
                        <button class="custom-btn btn-12">
                          <span
                            (click)="
                              viewReasonBtn(
                                getValue.fundFacilitatedForStartupReason
                              )
                            "
                            >Click!</span
                          ><span>Reason</span>
                        </button>
                      </div>
                    </div>
                    <div
                      class="submitted-details"
                      *ngIf="
                        getValue.fundFacilitatedForStartupStatus == 2 ||
                        getValue.fundFacilitatedForStartupStatus == 4 ||
                        getValue.fundFacilitatedForStartupStatus == 6
                      "
                    >
                      <div class="submiited-header">
                        <div class="name-header d-flex">
                          <span class="material-icons">fact_check</span>
                          <span class="ml-1">Submitted Details :</span>
                        </div>
                      </div>
                      <div class="submitted-content">
                        <div class="sub-div">
                          <p class="p-lbl">
                            Option Selected :
                            <b>{{
                              getValue.fundFacilitatedForStartupPresent
                            }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">
                            No. of Startups :
                            <b>{{
                              getValue.fundFacilitatedForStartupNoOfStartup
                            }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">Supporting Documents</p>
                          <ul class="sub-ul">
                            <li
                              *ngFor="
                                let list of getValue.fundFacilitatedForStartupDocuments
                              "
                            >
                              <a
                                href="{{ list.documentName }}"
                                target="_blank"
                                >{{ list.documentName }}</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div
                          class="sub-div"
                          *ngIf="
                            getValue.fundFacilitatedForStartupStatus == 3 ||
                            getValue.fundFacilitatedForStartupStatus == 6
                          "
                        >
                          <p class="p-lbl">Reason for clarification</p>
                          <p class="c-black comments">
                            {{ getValue.fundFacilitatedForStartupReason }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-12">
                    <div
                      class="guideline-div d-flex"
                      (click)="guidelinesBtn(guidelineValue[4])"
                    >
                      <span class="material-icons">description</span>
                      <span class="ml-1">Guidelines</span>
                    </div>
                  </div>
                </div>
              </div>
              <mat-action-row>
                <button mat-button color="warn" (click)="prevStep()">
                  Previous
                </button>
                <button mat-button color="primary" (click)="nextStep()">
                  Save & Continue
                </button>
              </mat-action-row>
            </mat-expansion-panel>
            <!-- qusetion 006 -->
            <mat-expansion-panel [expanded]="step === 5" (opened)="setStep(5)">
              <mat-expansion-panel-header class="d-flex">
                <h6>06.&nbsp;</h6>
                <h6>
                  <span *ngIf="mobileQuery.matches == false">
                    Is incubated SC/ST led Startups applied for Tamil Nadu SC/ST
                    Startup Fund
                  </span>
                  <span *ngIf="mobileQuery.matches == true">Question</span>
                </h6>
                <div class="success-span ml-auto">
                  <div
                    class="set success"
                    [style.width]="pickWidth(getValue.incubatesScStStatus)"
                    [style.background]="pickColor(getValue.incubatesScStStatus)"
                  >
                    <svg
                      version="1.1"
                      id="check"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 100 100"
                      xml:space="preserve"
                    >
                      <circle
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-miterlimit: 10;
                        "
                        cx="49.799"
                        cy="49.746"
                        r="44.757"
                      />
                      <polyline
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-linecap: round;
                          stroke-linejoin: round;
                          stroke-miterlimit: 10;
                        "
                        points="
                                                        27.114,51 41.402,65.288 72.485,34.205 "
                      />
                    </svg>
                    <span
                      [innerHTML]="innerValue(getValue.incubatesScStStatus)"
                    ></span>
                  </div>
                </div>
              </mat-expansion-panel-header>
              <div class="answer-div">
                <div class="row">
                  <div class="col-12 mb-2" *ngIf="mobileQuery.matches == true">
                    <h6>
                      Is incubated SC/ST led Startups applied for Tamil Nadu
                      SC/ST Startup Fund
                    </h6>
                  </div>
                  <div class="col-lg-8 col-md-8 col-12">
                    <div
                      *ngIf="
                        getValue.incubatesScStStatus != 2 &&
                        getValue.incubatesScStStatus != 4 &&
                        getValue.incubatesScStStatus != 5 &&
                        getValue.incubatesScStStatus != 6
                      "
                    >
                      <div class="mt-3">
                        <mat-radio-group
                          formControlName="incubatesScStCentre"
                          class="example-margin mt-4"
                          aria-label="Select an option"
                          (change)="
                            showOptions13(
                              $event.value,
                              '.11',
                              11,
                              '.set-succ11'
                            )
                          "
                          [ngClass]="{
                            'is-invalid':
                              setting.incubatesScStCentre.touched &&
                              setting.incubatesScStCentre.errors
                          }"
                        >
                          <mat-radio-button value="Yes">Yes</mat-radio-button>
                          <mat-radio-button value="No">No</mat-radio-button>
                        </mat-radio-group>
                        <br />
                        <mat-error
                          *ngIf="
                            setting.incubatesScStCentre.touched &&
                            setting.incubatesScStCentre.errors
                          "
                        >
                          <span
                            *ngIf="setting.incubatesScStCentre.errors.required"
                            >Answer is required</span
                          >
                        </mat-error>
                      </div>
                      <div class="opt-div" *ngIf="Options13checked == 'Yes'">
                        <div class="row">
                          <div class="col-lg-6 col-md-6 col-12">
                            <mat-form-field
                              class="material-full-width"
                              appearance="outline"
                            >
                              <mat-label
                                >No. of Startups
                                <span class="text-danger">*</span></mat-label
                              >
                              <input
                                matInput
                                placeholder="Enter No. of Startups "
                                (change)="
                                  setStatus($event, 'incubatesScStStatus', 7)
                                "
                                oninput="this.value = this.value.replace(/[^0-9]/g,'')"
                                formControlName="incubatesScStNoOfStartup"
                                [ngClass]="{
                                  'is-invalid':
                                    setting.incubatesScStNoOfStartup.touched &&
                                    setting.incubatesScStNoOfStartup.errors
                                }"
                              />
                              <mat-error
                                *ngIf="
                                  setting.incubatesScStNoOfStartup.touched &&
                                  setting.incubatesScStNoOfStartup.errors
                                "
                              >
                                <span
                                  *ngIf="
                                    setting.incubatesScStNoOfStartup.errors
                                      .required
                                  "
                                  >No. of Startups required</span
                                >
                              </mat-error>
                            </mat-form-field>
                          </div>
                          <div class="col-lg-6 col-md-6 col-12">
                            <div class="main-wrapper">
                              <div class="upload-main-wrapper">
                                <div class="upload-wrapper upload11">
                                  <input
                                    type="file"
                                    formControlName="incubatesScStImagefile"
                                    (change)="
                                      fileUpload(
                                        $event,
                                        '.upload11',
                                        11,
                                        '.set-succ11'
                                      )
                                    "
                                    accept=".pdf,.jpeg,.png,.jpg"
                                    id=""
                                    [ngClass]="{
                                      'is-invalid':
                                        setting.incubatesScStImagefile
                                          .touched &&
                                        setting.incubatesScStImagefile.errors
                                    }"
                                  />
                                  <svg
                                    version="1.1"
                                    xmlns="http://www.w3.org/2000/svg"
                                    xmlns:xlink="http://www.w3.org/1999/xlink"
                                    preserveAspectRatio="xMidYMid meet"
                                    viewBox="224.3881704980842 176.8527621722847 221.13266283524905 178.8472378277154"
                                    width="221.13"
                                    height="178.85"
                                  >
                                    <defs>
                                      <path
                                        d="M357.38 176.85C386.18 176.85 409.53 204.24 409.53 238.02C409.53 239.29 409.5 240.56 409.42 241.81C430.23 246.95 445.52 264.16 445.52 284.59C445.52 284.59 445.52 284.59 445.52 284.59C445.52 309.08 423.56 328.94 396.47 328.94C384.17 328.94 285.74 328.94 273.44 328.94C246.35 328.94 224.39 309.08 224.39 284.59C224.39 284.59 224.39 284.59 224.39 284.59C224.39 263.24 241.08 245.41 263.31 241.2C265.3 218.05 281.96 199.98 302.22 199.98C306.67 199.98 310.94 200.85 314.93 202.46C324.4 186.96 339.88 176.85 357.38 176.85Z"
                                        id="b1aO7LLtdW"
                                      ></path>
                                      <path
                                        d="M306.46 297.6L339.79 297.6L373.13 297.6L339.79 255.94L306.46 297.6Z"
                                        id="c4SXvvMdYD"
                                      ></path>
                                      <path
                                        d="M350.79 293.05L328.79 293.05L328.79 355.7L350.79 355.7L350.79 293.05Z"
                                        id="b11si2zUk"
                                      ></path>
                                    </defs>
                                    <g>
                                      <g>
                                        <g>
                                          <use
                                            xlink:href="#b1aO7LLtdW"
                                            opacity="1"
                                            fill="#ffffff"
                                            fill-opacity="1"
                                          ></use>
                                        </g>
                                        <g>
                                          <g>
                                            <use
                                              xlink:href="#c4SXvvMdYD"
                                              opacity="1"
                                              fill="#363535"
                                              fill-opacity="1"
                                            ></use>
                                          </g>
                                          <g>
                                            <use
                                              xlink:href="#b11si2zUk"
                                              opacity="1"
                                              fill="#363535"
                                              fill-opacity="1"
                                            ></use>
                                          </g>
                                        </g>
                                      </g>
                                    </g>
                                  </svg>
                                  <span class="file-upload-text"
                                    >Upload Documentary</span
                                  >
                                  <div class="file-success-text">
                                    <svg
                                      version="1.1"
                                      id="check"
                                      xmlns="http://www.w3.org/2000/svg"
                                      xmlns:xlink="http://www.w3.org/1999/xlink"
                                      x="0px"
                                      y="0px"
                                      viewBox="0 0 100 100"
                                      xml:space="preserve"
                                    >
                                      <circle
                                        style="
                                          fill: rgba(0, 0, 0, 0);
                                          stroke: #ffffff;
                                          stroke-width: 10;
                                          stroke-miterlimit: 10;
                                        "
                                        cx="49.799"
                                        cy="49.746"
                                        r="44.757"
                                      />
                                      <polyline
                                        style="
                                          fill: rgba(0, 0, 0, 0);
                                          stroke: #ffffff;
                                          stroke-width: 10;
                                          stroke-linecap: round;
                                          stroke-linejoin: round;
                                          stroke-miterlimit: 10;
                                        "
                                        points="
                                    27.114,51 41.402,65.288 72.485,34.205 "
                                      />
                                    </svg>
                                    <span>Uploading</span>
                                  </div>
                                </div>
                                <mat-error
                                  *ngIf="
                                    setting.incubatesScStImagefile.touched &&
                                    setting.incubatesScStImagefile.errors
                                  "
                                >
                                  <span
                                    *ngIf="
                                      setting.incubatesScStImagefile.errors
                                        .required
                                    "
                                    >Documentary is required</span
                                  >
                                </mat-error>
                                <div
                                  class="remove-wrapper upload11"
                                  (click)="
                                    removeFile('.upload11', 11, '.set-succ11')
                                  "
                                >
                                  <div class="file-success-text">
                                    <ion-icon
                                      name="close-circle-outline"
                                    ></ion-icon
                                    ><span>Remove Documentary</span>
                                  </div>
                                </div>
                                <p>
                                  <span class="noti-span"
                                    >(Supported Format: png,jpg,jpeg,pdf)
                                    <br />(max file size: 10mb)</span
                                  >
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="text-center mt-3"
                        *ngIf="getValue.incubatesScStStatus == 3"
                      >
                        <button class="custom-btn btn-12">
                          <span
                            (click)="
                              viewReasonBtn(getValue.incubatesScStReason)
                            "
                            >Click!</span
                          ><span>Reason</span>
                        </button>
                      </div>
                    </div>
                    <div
                      class="submitted-details"
                      *ngIf="
                        getValue.incubatesScStStatus == 2 ||
                        getValue.incubatesScStStatus == 4 ||
                        getValue.incubatesScStStatus == 6
                      "
                    >
                      <div class="submiited-header">
                        <div class="name-header d-flex">
                          <span class="material-icons">fact_check</span>
                          <span class="ml-1">Submitted Details :</span>
                        </div>
                      </div>
                      <div class="submitted-content">
                        <div class="sub-div">
                          <p class="p-lbl">
                            Option Selected :
                            <b>{{ getValue.incubatesScStCentre }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">
                            No. of Startups :
                            <b>{{ getValue.incubatesScStNoOfStartup }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">Supporting Documents</p>
                          <ul class="sub-ul">
                            <li
                              *ngFor="
                                let list of getValue.incubatesScStDocuments
                              "
                            >
                              <a
                                href="{{ list.documentName }}"
                                target="_blank"
                                >{{ list.documentName }}</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div
                          class="sub-div"
                          *ngIf="
                            getValue.incubatesScStStatus == 3 ||
                            getValue.incubatesScStStatus == 6
                          "
                        >
                          <p class="p-lbl">Reason for clarification</p>
                          <p class="c-black comments">
                            {{ getValue.incubatesScStReason }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-12">
                    <div
                      class="guideline-div d-flex"
                      (click)="guidelinesBtn(guidelineValue[5])"
                    >
                      <span class="material-icons">description</span>
                      <span class="ml-1">Guidelines</span>
                    </div>
                  </div>
                </div>
              </div>
              <mat-action-row>
                <button mat-button color="warn" (click)="prevStep()">
                  Previous
                </button>
                <button mat-button color="primary" (click)="nextStep()">
                  Save & Continue
                </button>
              </mat-action-row>
            </mat-expansion-panel>
            <!-- qusetion 007 -->
            <mat-expansion-panel [expanded]="step === 6" (opened)="setStep(6)">
              <mat-expansion-panel-header class="d-flex">
                <h6>07.&nbsp;</h6>
                <h6>
                  <span *ngIf="mobileQuery.matches == false">
                    Initiative to support rural development through technology &
                    rural entrepreneurship through collaborations /
                    hands-on-training
                  </span>
                  <span *ngIf="mobileQuery.matches == true">Question</span>
                </h6>
                <div class="success-span ml-auto">
                  <div
                    class="set success"
                    [style.width]="
                      pickWidth(getValue.ruralandRuralEntrepreneursStatus)
                    "
                    [style.background]="
                      pickColor(getValue.ruralandRuralEntrepreneursStatus)
                    "
                  >
                    <svg
                      version="1.1"
                      id="check"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 100 100"
                      xml:space="preserve"
                    >
                      <circle
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-miterlimit: 10;
                        "
                        cx="49.799"
                        cy="49.746"
                        r="44.757"
                      />
                      <polyline
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-linecap: round;
                          stroke-linejoin: round;
                          stroke-miterlimit: 10;
                        "
                        points="
                                                    27.114,51 41.402,65.288 72.485,34.205 "
                      />
                    </svg>
                    <span
                      [innerHTML]="
                        innerValue(getValue.ruralandRuralEntrepreneursStatus)
                      "
                    ></span>
                  </div>
                </div>
              </mat-expansion-panel-header>
              <div class="answer-div">
                <div class="row">
                  <div class="col-12 mb-2" *ngIf="mobileQuery.matches == true">
                    <h6>
                      Initiative to support rural development through technology
                      & rural entrepreneurship through collaborations /
                      hands-on-training
                    </h6>
                  </div>
                  <div class="col-lg-8 col-md-8 col-12">
                    <div
                      *ngIf="
                        getValue.ruralandRuralEntrepreneursStatus != 2 &&
                        getValue.ruralandRuralEntrepreneursStatus != 4 &&
                        getValue.ruralandRuralEntrepreneursStatus != 5 &&
                        getValue.ruralandRuralEntrepreneursStatus != 6
                      "
                    >
                      <div class="mt-3">
                        <mat-radio-group
                          formControlName="ruralandRuralEntrepreneursIncCentre"
                          class="example-margin mt-4"
                          aria-label="Select an option"
                          (change)="
                            showOptionsfour(
                              $event.value,
                              '.upload3',
                              3,
                              '.set-succ3'
                            )
                          "
                          [ngClass]="{
                            'is-invalid':
                              setting.ruralandRuralEntrepreneursIncCentre
                                .touched &&
                              setting.ruralandRuralEntrepreneursIncCentre.errors
                          }"
                        >
                          <mat-radio-button value="Yes">Yes</mat-radio-button>
                          <mat-radio-button value="No">No</mat-radio-button>
                        </mat-radio-group>
                        <br />
                        <mat-error
                          *ngIf="
                            setting.ruralandRuralEntrepreneursIncCentre
                              .touched &&
                            setting.ruralandRuralEntrepreneursIncCentre.errors
                          "
                        >
                          <span
                            *ngIf="
                              setting.ruralandRuralEntrepreneursIncCentre.errors
                                .required
                            "
                            >Answer is required</span
                          >
                        </mat-error>
                      </div>
                      <div class="opt-div" *ngIf="Optionsfourchecked == 'Yes'">
                        <div class="row">
                          <div class="col-lg-6 col-md-6 col-12">
                            <mat-form-field
                              class="material-full-width"
                              appearance="outline"
                            >
                              <mat-label
                                >No. of initiatives / programs
                                <span class="text-danger">*</span></mat-label
                              >
                              <input
                                matInput
                                placeholder="Enter No. of initiatives / programs"
                                (change)="
                                  setStatus(
                                    $event,
                                    'ruralandRuralEntrepreneursStatus',
                                    7
                                  )
                                "
                                oninput="this.value = this.value.replace(/[^0-9]/g,'')"
                                formControlName="ruralandRuralEntrepreneursNoOfInitiative"
                                [ngClass]="{
                                  'is-invalid':
                                    setting
                                      .ruralandRuralEntrepreneursNoOfInitiative
                                      .touched &&
                                    setting
                                      .ruralandRuralEntrepreneursNoOfInitiative
                                      .errors
                                }"
                              />
                              <mat-error
                                *ngIf="
                                  setting
                                    .ruralandRuralEntrepreneursNoOfInitiative
                                    .touched &&
                                  setting
                                    .ruralandRuralEntrepreneursNoOfInitiative
                                    .errors
                                "
                              >
                                <span
                                  *ngIf="
                                    setting
                                      .ruralandRuralEntrepreneursNoOfInitiative
                                      .errors.required
                                  "
                                  >No. of initiatives / programs is
                                  required</span
                                >
                              </mat-error>
                            </mat-form-field>
                          </div>
                          <div class="col-lg-6 col-md-6 col-12">
                            <div class="main-wrapper">
                              <div class="upload-main-wrapper">
                                <div class="upload-wrapper upload3">
                                  <input
                                    type="file"
                                    formControlName="ruralandRuralEntrepreneursImagefile"
                                    (change)="
                                      fileUpload(
                                        $event,
                                        '.upload3',
                                        3,
                                        '.set-succ3'
                                      )
                                    "
                                    accept=".pdf,.jpeg,.png,.jpg"
                                    id=""
                                    [ngClass]="{
                                      'is-invalid':
                                        setting
                                          .ruralandRuralEntrepreneursImagefile
                                          .touched &&
                                        setting
                                          .ruralandRuralEntrepreneursImagefile
                                          .errors
                                    }"
                                  />
                                  <svg
                                    version="1.1"
                                    xmlns="http://www.w3.org/2000/svg"
                                    xmlns:xlink="http://www.w3.org/1999/xlink"
                                    preserveAspectRatio="xMidYMid meet"
                                    viewBox="224.3881704980842 176.8527621722847 221.13266283524905 178.8472378277154"
                                    width="221.13"
                                    height="178.85"
                                  >
                                    <defs>
                                      <path
                                        d="M357.38 176.85C386.18 176.85 409.53 204.24 409.53 238.02C409.53 239.29 409.5 240.56 409.42 241.81C430.23 246.95 445.52 264.16 445.52 284.59C445.52 284.59 445.52 284.59 445.52 284.59C445.52 309.08 423.56 328.94 396.47 328.94C384.17 328.94 285.74 328.94 273.44 328.94C246.35 328.94 224.39 309.08 224.39 284.59C224.39 284.59 224.39 284.59 224.39 284.59C224.39 263.24 241.08 245.41 263.31 241.2C265.3 218.05 281.96 199.98 302.22 199.98C306.67 199.98 310.94 200.85 314.93 202.46C324.4 186.96 339.88 176.85 357.38 176.85Z"
                                        id="b1aO7LLtdW"
                                      ></path>
                                      <path
                                        d="M306.46 297.6L339.79 297.6L373.13 297.6L339.79 255.94L306.46 297.6Z"
                                        id="c4SXvvMdYD"
                                      ></path>
                                      <path
                                        d="M350.79 293.05L328.79 293.05L328.79 355.7L350.79 355.7L350.79 293.05Z"
                                        id="b11si2zUk"
                                      ></path>
                                    </defs>
                                    <g>
                                      <g>
                                        <g>
                                          <use
                                            xlink:href="#b1aO7LLtdW"
                                            opacity="1"
                                            fill="#ffffff"
                                            fill-opacity="1"
                                          ></use>
                                        </g>
                                        <g>
                                          <g>
                                            <use
                                              xlink:href="#c4SXvvMdYD"
                                              opacity="1"
                                              fill="#363535"
                                              fill-opacity="1"
                                            ></use>
                                          </g>
                                          <g>
                                            <use
                                              xlink:href="#b11si2zUk"
                                              opacity="1"
                                              fill="#363535"
                                              fill-opacity="1"
                                            ></use>
                                          </g>
                                        </g>
                                      </g>
                                    </g>
                                  </svg>
                                  <span class="file-upload-text"
                                    >Upload Documentary</span
                                  >
                                  <div class="file-success-text">
                                    <svg
                                      version="1.1"
                                      id="check"
                                      xmlns="http://www.w3.org/2000/svg"
                                      xmlns:xlink="http://www.w3.org/1999/xlink"
                                      x="0px"
                                      y="0px"
                                      viewBox="0 0 100 100"
                                      xml:space="preserve"
                                    >
                                      <circle
                                        style="
                                          fill: rgba(0, 0, 0, 0);
                                          stroke: #ffffff;
                                          stroke-width: 10;
                                          stroke-miterlimit: 10;
                                        "
                                        cx="49.799"
                                        cy="49.746"
                                        r="44.757"
                                      />
                                      <polyline
                                        style="
                                          fill: rgba(0, 0, 0, 0);
                                          stroke: #ffffff;
                                          stroke-width: 10;
                                          stroke-linecap: round;
                                          stroke-linejoin: round;
                                          stroke-miterlimit: 10;
                                        "
                                        points="
                                27.114,51 41.402,65.288 72.485,34.205 "
                                      />
                                    </svg>
                                    <span>Uploading</span>
                                  </div>
                                </div>
                                <mat-error
                                  *ngIf="
                                    setting.ruralandRuralEntrepreneursImagefile
                                      .touched &&
                                    setting.ruralandRuralEntrepreneursImagefile
                                      .errors
                                  "
                                >
                                  <span
                                    *ngIf="
                                      setting
                                        .ruralandRuralEntrepreneursImagefile
                                        .errors.required
                                    "
                                    >Documentary is required</span
                                  >
                                </mat-error>
                                <div
                                  class="remove-wrapper upload3"
                                  (click)="
                                    removeFile('.upload3', 3, '.set-succ3')
                                  "
                                >
                                  <div class="file-success-text">
                                    <ion-icon
                                      name="close-circle-outline"
                                    ></ion-icon
                                    ><span>Remove Documentary</span>
                                  </div>
                                </div>
                                <p>
                                  <span class="noti-span"
                                    >(Supported Format: png,jpg,jpeg,pdf)
                                    <br />(max file size: 10mb)</span
                                  >
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="text-center mt-3"
                        *ngIf="getValue.ruralandRuralEntrepreneursStatus == 3"
                      >
                        <button class="custom-btn btn-12">
                          <span
                            (click)="
                              viewReasonBtn(
                                getValue.ruralandRuralEntrepreneursReason
                              )
                            "
                            >Click!</span
                          ><span>Reason</span>
                        </button>
                      </div>
                    </div>
                    <div
                      class="submitted-details"
                      *ngIf="
                        getValue.ruralandRuralEntrepreneursStatus == 2 ||
                        getValue.ruralandRuralEntrepreneursStatus == 4 ||
                        getValue.ruralandRuralEntrepreneursStatus == 6
                      "
                    >
                      <div class="submiited-header">
                        <div class="name-header d-flex">
                          <span class="material-icons">fact_check</span>
                          <span class="ml-1">Submitted Details :</span>
                        </div>
                      </div>
                      <div class="submitted-content">
                        <div class="sub-div">
                          <p class="p-lbl">
                            Option Selected :
                            <b>{{
                              getValue.ruralandRuralEntrepreneursIncCentre
                            }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">
                            No. of initiatives / programs :
                            <b>{{
                              getValue.ruralandRuralEntrepreneursNoOfInitiative
                            }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">Supporting Documents</p>
                          <ul class="sub-ul">
                            <li
                              *ngFor="
                                let list of getValue.ruralandRuralEntrepreneursDocuments
                              "
                            >
                              <a
                                href="{{ list.documentName }}"
                                target="_blank"
                                >{{ list.documentName }}</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div
                          class="sub-div"
                          *ngIf="
                            getValue.ruralandRuralEntrepreneursStatus == 3 ||
                            getValue.ruralandRuralEntrepreneursStatus == 6
                          "
                        >
                          <p class="p-lbl">Reason for clarification</p>
                          <p class="c-black comments">
                            {{ getValue.ruralandRuralEntrepreneursReason }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-12">
                    <div
                      class="guideline-div d-flex"
                      (click)="guidelinesBtn(guidelineValue[6])"
                    >
                      <span class="material-icons">description</span>
                      <span class="ml-1">Guidelines</span>
                    </div>
                  </div>
                </div>
              </div>
              <mat-action-row>
                <button mat-button color="warn" (click)="prevStep()">
                  Previous
                </button>
                <button mat-button color="primary" (click)="nextStep()">
                  Save & Continue
                </button>
              </mat-action-row>
            </mat-expansion-panel>
            <!-- qusetion 008 -->
            <mat-expansion-panel [expanded]="step === 7" (opened)="setStep(7)">
              <mat-expansion-panel-header>
                <h6>08.&nbsp;</h6>
                <h6>
                  <span *ngIf="mobileQuery.matches == false">
                    Employment generation by incubated Startups
                  </span>
                  <span *ngIf="mobileQuery.matches == true">Question</span>
                </h6>
                <div class="success-span ml-auto">
                  <div
                    class="set success"
                    [style.width]="
                      pickWidth(getValue.employmentGenerationStatus)
                    "
                    [style.background]="
                      pickColor(getValue.employmentGenerationStatus)
                    "
                  >
                    <svg
                      version="1.1"
                      id="check"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 100 100"
                      xml:space="preserve"
                    >
                      <circle
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-miterlimit: 10;
                        "
                        cx="49.799"
                        cy="49.746"
                        r="44.757"
                      />
                      <polyline
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-linecap: round;
                          stroke-linejoin: round;
                          stroke-miterlimit: 10;
                        "
                        points="
                                                        27.114,51 41.402,65.288 72.485,34.205 "
                      />
                    </svg>
                    <span
                      [innerHTML]="
                        innerValue(getValue.employmentGenerationStatus)
                      "
                    ></span>
                  </div>
                </div>
              </mat-expansion-panel-header>
              <div class="answer-div">
                <div class="row">
                  <div class="col-12 mb-2" *ngIf="mobileQuery.matches == true">
                    <h6>Employment generation by incubated Startups</h6>
                  </div>
                  <div class="col-lg-8 col-md-8 col-12">
                    <div
                      *ngIf="
                        getValue.employmentGenerationStatus != 2 &&
                        getValue.employmentGenerationStatus != 4 &&
                        getValue.employmentGenerationStatus != 5 &&
                        getValue.employmentGenerationStatus != 6
                      "
                    >
                      <div class="mt-3">
                        <mat-radio-group
                          formControlName="employmentGenerationIncCentre"
                          class="example-margin mt-4"
                          aria-label="Select an option"
                          (change)="
                            showOptionssix(
                              $event.value,
                              '.upload5',
                              5,
                              '.set-succ5'
                            )
                          "
                          [ngClass]="{
                            'is-invalid':
                              setting.employmentGenerationIncCentre.touched &&
                              setting.employmentGenerationIncCentre.errors
                          }"
                        >
                          <mat-radio-button value="Yes">Yes</mat-radio-button>
                          <mat-radio-button value="No">No</mat-radio-button>
                        </mat-radio-group>
                        <br />
                        <mat-error
                          *ngIf="
                            setting.employmentGenerationIncCentre.touched &&
                            setting.employmentGenerationIncCentre.errors
                          "
                        >
                          <span
                            *ngIf="
                              setting.employmentGenerationIncCentre.errors
                                .required
                            "
                            >Answer is required</span
                          >
                        </mat-error>
                      </div>
                      <div class="opt-div" *ngIf="Optionssixchecked == 'Yes'">
                        <div class="row">
                          <div class="col-lg-6 col-md-6 col-12">
                            <mat-form-field
                              class="material-full-width"
                              appearance="outline"
                            >
                              <mat-label
                                >No of Employment Generated
                                <span class="text-danger">*</span></mat-label
                              >
                              <input
                                matInput
                                placeholder="Enter No of Employment Generated"
                                oninput="this.value = this.value.replace(/[^0-9]/g,'')"
                                (change)="
                                  setStatus(
                                    $event,
                                    'employmentGenerationStatus',
                                    7
                                  )
                                "
                                formControlName="employmentGenerationNoOfEmploymentGeneration"
                                [ngClass]="{
                                  'is-invalid':
                                    setting
                                      .employmentGenerationNoOfEmploymentGeneration
                                      .touched &&
                                    setting
                                      .employmentGenerationNoOfEmploymentGeneration
                                      .errors
                                }"
                              />
                              <mat-error
                                *ngIf="
                                  setting
                                    .employmentGenerationNoOfEmploymentGeneration
                                    .touched &&
                                  setting
                                    .employmentGenerationNoOfEmploymentGeneration
                                    .errors
                                "
                              >
                                <span
                                  *ngIf="
                                    setting
                                      .employmentGenerationNoOfEmploymentGeneration
                                      .errors.required
                                  "
                                  >No of Employment Generated is required</span
                                >
                              </mat-error>
                            </mat-form-field>
                          </div>
                          <div class="col-lg-6 col-md-6 col-12">
                            <div class="main-wrapper">
                              <div class="upload-main-wrapper">
                                <div class="upload-wrapper upload5">
                                  <input
                                    type="file"
                                    formControlName="employmentGenerationImagefile"
                                    (change)="
                                      fileUpload(
                                        $event,
                                        '.upload5',
                                        5,
                                        '.set-succ5'
                                      )
                                    "
                                    accept=".pdf,.jpeg,.png,.jpg"
                                    id=""
                                    [ngClass]="{
                                      'is-invalid':
                                        setting.employmentGenerationImagefile
                                          .touched &&
                                        setting.employmentGenerationImagefile
                                          .errors
                                    }"
                                  />
                                  <svg
                                    version="1.1"
                                    xmlns="http://www.w3.org/2000/svg"
                                    xmlns:xlink="http://www.w3.org/1999/xlink"
                                    preserveAspectRatio="xMidYMid meet"
                                    viewBox="224.3881704980842 176.8527621722847 221.13266283524905 178.8472378277154"
                                    width="221.13"
                                    height="178.85"
                                  >
                                    <defs>
                                      <path
                                        d="M357.38 176.85C386.18 176.85 409.53 204.24 409.53 238.02C409.53 239.29 409.5 240.56 409.42 241.81C430.23 246.95 445.52 264.16 445.52 284.59C445.52 284.59 445.52 284.59 445.52 284.59C445.52 309.08 423.56 328.94 396.47 328.94C384.17 328.94 285.74 328.94 273.44 328.94C246.35 328.94 224.39 309.08 224.39 284.59C224.39 284.59 224.39 284.59 224.39 284.59C224.39 263.24 241.08 245.41 263.31 241.2C265.3 218.05 281.96 199.98 302.22 199.98C306.67 199.98 310.94 200.85 314.93 202.46C324.4 186.96 339.88 176.85 357.38 176.85Z"
                                        id="b1aO7LLtdW"
                                      ></path>
                                      <path
                                        d="M306.46 297.6L339.79 297.6L373.13 297.6L339.79 255.94L306.46 297.6Z"
                                        id="c4SXvvMdYD"
                                      ></path>
                                      <path
                                        d="M350.79 293.05L328.79 293.05L328.79 355.7L350.79 355.7L350.79 293.05Z"
                                        id="b11si2zUk"
                                      ></path>
                                    </defs>
                                    <g>
                                      <g>
                                        <g>
                                          <use
                                            xlink:href="#b1aO7LLtdW"
                                            opacity="1"
                                            fill="#ffffff"
                                            fill-opacity="1"
                                          ></use>
                                        </g>
                                        <g>
                                          <g>
                                            <use
                                              xlink:href="#c4SXvvMdYD"
                                              opacity="1"
                                              fill="#363535"
                                              fill-opacity="1"
                                            ></use>
                                          </g>
                                          <g>
                                            <use
                                              xlink:href="#b11si2zUk"
                                              opacity="1"
                                              fill="#363535"
                                              fill-opacity="1"
                                            ></use>
                                          </g>
                                        </g>
                                      </g>
                                    </g>
                                  </svg>
                                  <span class="file-upload-text"
                                    >Upload Documentary</span
                                  >
                                  <div class="file-success-text">
                                    <svg
                                      version="1.1"
                                      id="check"
                                      xmlns="http://www.w3.org/2000/svg"
                                      xmlns:xlink="http://www.w3.org/1999/xlink"
                                      x="0px"
                                      y="0px"
                                      viewBox="0 0 100 100"
                                      xml:space="preserve"
                                    >
                                      <circle
                                        style="
                                          fill: rgba(0, 0, 0, 0);
                                          stroke: #ffffff;
                                          stroke-width: 10;
                                          stroke-miterlimit: 10;
                                        "
                                        cx="49.799"
                                        cy="49.746"
                                        r="44.757"
                                      />
                                      <polyline
                                        style="
                                          fill: rgba(0, 0, 0, 0);
                                          stroke: #ffffff;
                                          stroke-width: 10;
                                          stroke-linecap: round;
                                          stroke-linejoin: round;
                                          stroke-miterlimit: 10;
                                        "
                                        points="
                                27.114,51 41.402,65.288 72.485,34.205 "
                                      />
                                    </svg>
                                    <span>Uploading</span>
                                  </div>
                                </div>
                                <mat-error
                                  *ngIf="
                                    setting.employmentGenerationImagefile
                                      .touched &&
                                    setting.employmentGenerationImagefile.errors
                                  "
                                >
                                  <span
                                    *ngIf="
                                      setting.employmentGenerationImagefile
                                        .errors.required
                                    "
                                    >Documentary is required</span
                                  >
                                </mat-error>
                                <div
                                  class="remove-wrapper upload5"
                                  (click)="
                                    removeFile('.upload5', 5, '.set-succ5')
                                  "
                                >
                                  <div class="file-success-text">
                                    <ion-icon
                                      name="close-circle-outline"
                                    ></ion-icon
                                    ><span>Remove Documentary</span>
                                  </div>
                                </div>
                                <p>
                                  <span class="noti-span"
                                    >(Supported Format: png,jpg,jpeg,pdf)
                                    <br />(max file size: 10mb)</span
                                  >
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="text-center mt-3"
                        *ngIf="getValue.employmentGenerationStatus == 3"
                      >
                        <button class="custom-btn btn-12">
                          <span
                            (click)="
                              viewReasonBtn(getValue.employmentGenerationReason)
                            "
                            >Click!</span
                          ><span>Reason</span>
                        </button>
                      </div>
                    </div>
                    <div
                      class="submitted-details"
                      *ngIf="
                        getValue.employmentGenerationStatus == 2 ||
                        getValue.employmentGenerationStatus == 4 ||
                        getValue.employmentGenerationStatus == 6
                      "
                    >
                      <div class="submiited-header">
                        <div class="name-header d-flex">
                          <span class="material-icons">fact_check</span>
                          <span class="ml-1">Submitted Details :</span>
                        </div>
                      </div>
                      <div class="submitted-content">
                        <div class="sub-div">
                          <p class="p-lbl">
                            Option Selected :
                            <b>{{ getValue.employmentGenerationIncCentre }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">
                            No of Employment Generated :
                            <b>{{
                              getValue.employmentGenerationNoOfEmploymentGeneration
                            }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">Supporting Documents</p>
                          <ul class="sub-ul">
                            <li
                              *ngFor="
                                let list of getValue.employmentGenerationDocuments
                              "
                            >
                              <a
                                href="{{ list.documentName }}"
                                target="_blank"
                                >{{ list.documentName }}</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div
                          class="sub-div"
                          *ngIf="
                            getValue.employmentGenerationStatus == 3 ||
                            getValue.employmentGenerationStatus == 6
                          "
                        >
                          <p class="p-lbl">Reason for clarification</p>
                          <p class="c-black comments">
                            {{ getValue.employmentGenerationReason }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-12">
                    <div
                      class="guideline-div d-flex"
                      (click)="guidelinesBtn(guidelineValue[7])"
                    >
                      <span class="material-icons">description</span>
                      <span class="ml-1">Guidelines</span>
                    </div>
                  </div>
                </div>
              </div>

              <mat-action-row>
                <button mat-button color="warn" (click)="prevStep()">
                  Previous
                </button>
                <button mat-button color="primary" (click)="nextStep()">
                  Save & Continue
                </button>
              </mat-action-row>
            </mat-expansion-panel>
            <!-- qusetion 009 -->
            <mat-expansion-panel [expanded]="step === 8" (opened)="setStep(8)">
              <mat-expansion-panel-header class="d-flex">
                <h6>09.&nbsp;</h6>
                <h6>
                  <span *ngIf="mobileQuery.matches == false">
                    Innovative Startups among Incubatees solving community
                    centric problems
                  </span>
                  <span *ngIf="mobileQuery.matches == true">Question</span>
                </h6>
                <div class="success-span ml-auto">
                  <div
                    class="set success"
                    [style.width]="pickWidth(getValue.innovativeStartupsStatus)"
                    [style.background]="
                      pickColor(getValue.innovativeStartupsStatus)
                    "
                  >
                    <svg
                      version="1.1"
                      id="check"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 100 100"
                      xml:space="preserve"
                    >
                      <circle
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-miterlimit: 10;
                        "
                        cx="49.799"
                        cy="49.746"
                        r="44.757"
                      />
                      <polyline
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-linecap: round;
                          stroke-linejoin: round;
                          stroke-miterlimit: 10;
                        "
                        points="
                                                27.114,51 41.402,65.288 72.485,34.205 "
                      />
                    </svg>
                    <span
                      [innerHTML]="
                        innerValue(getValue.innovativeStartupsStatus)
                      "
                    ></span>
                  </div>
                </div>
              </mat-expansion-panel-header>
              <div class="answer-div">
                <div class="row">
                  <div class="col-12 mb-2" *ngIf="mobileQuery.matches == true">
                    <h6>
                      Innovative Startups among Incubatees solving community
                      centric problems
                    </h6>
                  </div>
                  <div class="col-lg-8 col-md-8 col-12">
                    <div
                      *ngIf="
                        getValue.innovativeStartupsStatus != 2 &&
                        getValue.innovativeStartupsStatus != 4 &&
                        getValue.innovativeStartupsStatus != 5 &&
                        getValue.innovativeStartupsStatus != 6
                      "
                    >
                      <div class="mt-3">
                        <mat-radio-group
                          formControlName="innovativeStartupsIncCentre"
                          class="example-margin mt-4"
                          aria-label="Select an option"
                          (change)="
                            showOptionsfive(
                              $event.value,
                              '.upload4',
                              4,
                              '.set-succ4'
                            )
                          "
                          [ngClass]="{
                            'is-invalid':
                              setting.innovativeStartupsIncCentre.touched &&
                              setting.innovativeStartupsIncCentre.errors
                          }"
                        >
                          <mat-radio-button value="Yes">Yes</mat-radio-button>
                          <mat-radio-button value="No">No</mat-radio-button>
                        </mat-radio-group>
                        <br />
                        <mat-error
                          *ngIf="
                            setting.innovativeStartupsIncCentre.touched &&
                            setting.innovativeStartupsIncCentre.errors
                          "
                        >
                          <span
                            *ngIf="
                              setting.innovativeStartupsIncCentre.errors
                                .required
                            "
                            >Answer is required</span
                          >
                        </mat-error>
                      </div>
                      <div class="opt-div" *ngIf="Optionsfivechecked == 'Yes'">
                        <div class="row">
                          <div class="col-lg-6 col-md-6 col-12">
                            <mat-form-field
                              class="material-full-width"
                              appearance="outline"
                            >
                              <mat-label
                                >No of Startups
                                <span class="text-danger">*</span></mat-label
                              >
                              <input
                                matInput
                                placeholder="Enter No of Startups"
                                (change)="
                                  setStatus(
                                    $event,
                                    'innovativeStartupsStatus',
                                    7
                                  )
                                "
                                oninput="this.value = this.value.replace(/[^0-9]/g,'')"
                                formControlName="innovativeStartupsNoOfStartup"
                                [ngClass]="{
                                  'is-invalid':
                                    setting.innovativeStartupsNoOfStartup
                                      .touched &&
                                    setting.innovativeStartupsNoOfStartup.errors
                                }"
                              />
                              <mat-error
                                *ngIf="
                                  setting.innovativeStartupsNoOfStartup
                                    .touched &&
                                  setting.innovativeStartupsNoOfStartup.errors
                                "
                              >
                                <span
                                  *ngIf="
                                    setting.innovativeStartupsNoOfStartup.errors
                                      .required
                                  "
                                  >No of Startups is required</span
                                >
                              </mat-error>
                            </mat-form-field>
                          </div>
                          <div class="col-lg-6 col-md-6 col-12">
                            <div class="main-wrapper">
                              <div class="upload-main-wrapper">
                                <div class="upload-wrapper upload4">
                                  <input
                                    type="file"
                                    formControlName="innovativeStartupsImagefile"
                                    (change)="
                                      fileUpload(
                                        $event,
                                        '.upload4',
                                        4,
                                        '.set-succ4'
                                      )
                                    "
                                    accept=".pdf,.jpeg,.png,.jpg"
                                    id=""
                                    [ngClass]="{
                                      'is-invalid':
                                        setting.innovativeStartupsImagefile
                                          .touched &&
                                        setting.innovativeStartupsImagefile
                                          .errors
                                    }"
                                  />
                                  <svg
                                    version="1.1"
                                    xmlns="http://www.w3.org/2000/svg"
                                    xmlns:xlink="http://www.w3.org/1999/xlink"
                                    preserveAspectRatio="xMidYMid meet"
                                    viewBox="224.3881704980842 176.8527621722847 221.13266283524905 178.8472378277154"
                                    width="221.13"
                                    height="178.85"
                                  >
                                    <defs>
                                      <path
                                        d="M357.38 176.85C386.18 176.85 409.53 204.24 409.53 238.02C409.53 239.29 409.5 240.56 409.42 241.81C430.23 246.95 445.52 264.16 445.52 284.59C445.52 284.59 445.52 284.59 445.52 284.59C445.52 309.08 423.56 328.94 396.47 328.94C384.17 328.94 285.74 328.94 273.44 328.94C246.35 328.94 224.39 309.08 224.39 284.59C224.39 284.59 224.39 284.59 224.39 284.59C224.39 263.24 241.08 245.41 263.31 241.2C265.3 218.05 281.96 199.98 302.22 199.98C306.67 199.98 310.94 200.85 314.93 202.46C324.4 186.96 339.88 176.85 357.38 176.85Z"
                                        id="b1aO7LLtdW"
                                      ></path>
                                      <path
                                        d="M306.46 297.6L339.79 297.6L373.13 297.6L339.79 255.94L306.46 297.6Z"
                                        id="c4SXvvMdYD"
                                      ></path>
                                      <path
                                        d="M350.79 293.05L328.79 293.05L328.79 355.7L350.79 355.7L350.79 293.05Z"
                                        id="b11si2zUk"
                                      ></path>
                                    </defs>
                                    <g>
                                      <g>
                                        <g>
                                          <use
                                            xlink:href="#b1aO7LLtdW"
                                            opacity="1"
                                            fill="#ffffff"
                                            fill-opacity="1"
                                          ></use>
                                        </g>
                                        <g>
                                          <g>
                                            <use
                                              xlink:href="#c4SXvvMdYD"
                                              opacity="1"
                                              fill="#363535"
                                              fill-opacity="1"
                                            ></use>
                                          </g>
                                          <g>
                                            <use
                                              xlink:href="#b11si2zUk"
                                              opacity="1"
                                              fill="#363535"
                                              fill-opacity="1"
                                            ></use>
                                          </g>
                                        </g>
                                      </g>
                                    </g>
                                  </svg>
                                  <span class="file-upload-text"
                                    >Upload Documentary</span
                                  >
                                  <div class="file-success-text">
                                    <svg
                                      version="1.1"
                                      id="check"
                                      xmlns="http://www.w3.org/2000/svg"
                                      xmlns:xlink="http://www.w3.org/1999/xlink"
                                      x="0px"
                                      y="0px"
                                      viewBox="0 0 100 100"
                                      xml:space="preserve"
                                    >
                                      <circle
                                        style="
                                          fill: rgba(0, 0, 0, 0);
                                          stroke: #ffffff;
                                          stroke-width: 10;
                                          stroke-miterlimit: 10;
                                        "
                                        cx="49.799"
                                        cy="49.746"
                                        r="44.757"
                                      />
                                      <polyline
                                        style="
                                          fill: rgba(0, 0, 0, 0);
                                          stroke: #ffffff;
                                          stroke-width: 10;
                                          stroke-linecap: round;
                                          stroke-linejoin: round;
                                          stroke-miterlimit: 10;
                                        "
                                        points="
                                                                        27.114,51 41.402,65.288 72.485,34.205 "
                                      />
                                    </svg>
                                    <span>Uploading</span>
                                  </div>
                                </div>
                                <mat-error
                                  *ngIf="
                                    setting.innovativeStartupsImagefile
                                      .touched &&
                                    setting.innovativeStartupsImagefile.errors
                                  "
                                >
                                  <span
                                    *ngIf="
                                      setting.innovativeStartupsImagefile.errors
                                        .required
                                    "
                                    >Documentary is required</span
                                  >
                                </mat-error>
                                <div
                                  class="remove-wrapper upload4"
                                  (click)="
                                    removeFile('.upload4', 4, '.set-succ4')
                                  "
                                >
                                  <div class="file-success-text">
                                    <ion-icon
                                      name="close-circle-outline"
                                    ></ion-icon
                                    ><span>Remove Documentary</span>
                                  </div>
                                </div>
                                <p>
                                  <span class="noti-span"
                                    >(Supported Format: png,jpg,jpeg,pdf)
                                    <br />(max file size: 10mb)</span
                                  >
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="text-center mt-3"
                        *ngIf="getValue.innovativeStartupsStatus == 3"
                      >
                        <button class="custom-btn btn-12">
                          <span
                            (click)="
                              viewReasonBtn(getValue.innovativeStartupsReason)
                            "
                            >Click!</span
                          ><span>Reason</span>
                        </button>
                      </div>
                    </div>
                    <div
                      class="submitted-details"
                      *ngIf="
                        getValue.innovativeStartupsStatus == 2 ||
                        getValue.innovativeStartupsStatus == 4 ||
                        getValue.innovativeStartupsStatus == 6
                      "
                    >
                      <div class="submiited-header">
                        <div class="name-header d-flex">
                          <span class="material-icons">fact_check</span>
                          <span class="ml-1">Submitted Details :</span>
                        </div>
                      </div>
                      <div class="submitted-content">
                        <div class="sub-div">
                          <p class="p-lbl">
                            Option Selected :
                            <b>{{ getValue.innovativeStartupsIncCentre }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">
                            No of Startups :
                            <b>{{ getValue.innovativeStartupsNoOfStartup }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">Supporting Documents</p>
                          <ul class="sub-ul">
                            <li
                              *ngFor="
                                let list of getValue.innovativeStartupsDocuments
                              "
                            >
                              <a
                                href="{{ list.documentName }}"
                                target="_blank"
                                >{{ list.documentName }}</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div
                          class="sub-div"
                          *ngIf="
                            getValue.innovativeStartupsStatus == 3 ||
                            getValue.innovativeStartupsStatus == 6
                          "
                        >
                          <p class="p-lbl">Reason for clarification</p>
                          <p class="c-black comments">
                            {{ getValue.innovativeStartupsReason }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-12">
                    <div
                      class="guideline-div d-flex"
                      (click)="guidelinesBtn(guidelineValue[8])"
                    >
                      <span class="material-icons">description</span>
                      <span class="ml-1">Guidelines</span>
                    </div>
                  </div>
                </div>
              </div>
              <mat-action-row>
                <button mat-button color="warn" (click)="prevStep()">
                  Previous
                </button>
                <button mat-button color="primary" (click)="nextStep()">
                  Save & Continue
                </button>
              </mat-action-row>
            </mat-expansion-panel>
          </mat-accordion>
        </div>
      </div>
    </div>
  </div>
</section>
